// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */
var PagSeguro = function(t) {
  "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
  var e, n, r = (function(t, e) {
      ! function(t) {
        var e = "0123456789abcdefghijklmnopqrstuvwxyz";

        function n(t) { return e.charAt(t) }

        function r(t, e) { return t & e }

        function i(t, e) { return t | e }

        function o(t, e) { return t ^ e }

        function s(t, e) { return t & ~e }

        function a(t) { if (0 == t) return -1; var e = 0; return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e }

        function u(t) { for (var e = 0; 0 != t;) t &= t - 1, ++e; return e }
        var h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
          c = "=";

        function l(t) {
          var e, n, r = "";
          for (e = 0; e + 3 <= t.length; e += 3) n = parseInt(t.substring(e, e + 3), 16), r += h.charAt(n >> 6) + h.charAt(63 & n);
          for (e + 1 == t.length ? (n = parseInt(t.substring(e, e + 1), 16), r += h.charAt(n << 2)) : e + 2 == t.length && (n = parseInt(t.substring(e, e + 2), 16), r += h.charAt(n >> 2) + h.charAt((3 & n) << 4));
            (3 & r.length) > 0;) r += c;
          return r
        }

        function f(t) {
          var e, r = "",
            i = 0,
            o = 0;
          for (e = 0; e < t.length && t.charAt(e) != c; ++e) {
            var s = h.indexOf(t.charAt(e));
            s < 0 || (0 == i ? (r += n(s >> 2), o = 3 & s, i = 1) : 1 == i ? (r += n(o << 2 | s >> 4), o = 15 & s, i = 2) : 2 == i ? (r += n(o), r += n(s >> 2), o = 3 & s, i = 3) : (r += n(o << 2 | s >> 4), r += n(15 & s), i = 0))
          }
          return 1 == i && (r += n(o << 2)), r
        }
        var d, p, g = function(t, e) {
            return (g = Object.setPrototypeOf || { __proto__: [] }
              instanceof Array && function(t, e) { t.__proto__ = e } || function(t, e) { for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]) })(t, e)
          },
          m = function(t) {
            var e;
            if (void 0 === d) {
              var n = "0123456789ABCDEF",
                r = " \f\n\r\t \u2028\u2029";
              for (d = {}, e = 0; e < 16; ++e) d[n.charAt(e)] = e;
              for (n = n.toLowerCase(), e = 10; e < 16; ++e) d[n.charAt(e)] = e;
              for (e = 0; e < r.length; ++e) d[r.charAt(e)] = -1
            }
            var i = [],
              o = 0,
              s = 0;
            for (e = 0; e < t.length; ++e) {
              var a = t.charAt(e);
              if ("=" == a) break;
              if (-1 != (a = d[a])) {
                if (void 0 === a) throw new Error("Illegal character at offset " + e);
                o |= a, ++s >= 2 ? (i[i.length] = o, o = 0, s = 0) : o <<= 4
              }
            }
            if (s) throw new Error("Hex encoding incomplete: 4 bits missing");
            return i
          },
          v = {
            decode: function(t) {
              var e;
              if (void 0 === p) { var n = "= \f\n\r\t \u2028\u2029"; for (p = Object.create(null), e = 0; e < 64; ++e) p["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e)] = e; for (e = 0; e < n.length; ++e) p[n.charAt(e)] = -1 }
              var r = [],
                i = 0,
                o = 0;
              for (e = 0; e < t.length; ++e) {
                var s = t.charAt(e);
                if ("=" == s) break;
                if (-1 != (s = p[s])) {
                  if (void 0 === s) throw new Error("Illegal character at offset " + e);
                  i |= s, ++o >= 4 ? (r[r.length] = i >> 16, r[r.length] = i >> 8 & 255, r[r.length] = 255 & i, i = 0, o = 0) : i <<= 6
                }
              }
              switch (o) {
                case 1:
                  throw new Error("Base64 encoding incomplete: at least 2 bits missing");
                case 2:
                  r[r.length] = i >> 10;
                  break;
                case 3:
                  r[r.length] = i >> 16, r[r.length] = i >> 8 & 255
              }
              return r
            },
            re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
            unarmor: function(t) {
              var e = v.re.exec(t);
              if (e)
                if (e[1]) t = e[1];
                else {
                  if (!e[2]) throw new Error("RegExp out of sync");
                  t = e[2]
                }
              return v.decode(t)
            }
          },
          y = function() {
            function t(t) { this.buf = [+t || 0] }
            return t.prototype.mulAdd = function(t, e) {
              var n, r, i = this.buf,
                o = i.length;
              for (n = 0; n < o; ++n)(r = i[n] * t + e) < 1e13 ? e = 0 : r -= 1e13 * (e = 0 | r / 1e13), i[n] = r;
              e > 0 && (i[n] = e)
            }, t.prototype.sub = function(t) {
              var e, n, r = this.buf,
                i = r.length;
              for (e = 0; e < i; ++e)(n = r[e] - t) < 0 ? (n += 1e13, t = 1) : t = 0, r[e] = n;
              for (; 0 === r[r.length - 1];) r.pop()
            }, t.prototype.toString = function(t) { if (10 != (t || 10)) throw new Error("only base 10 is supported"); for (var e = this.buf, n = e[e.length - 1].toString(), r = e.length - 2; r >= 0; --r) n += (1e13 + e[r]).toString().substring(1); return n }, t.prototype.valueOf = function() { for (var t = this.buf, e = 0, n = t.length - 1; n >= 0; --n) e = 1e13 * e + t[n]; return e }, t.prototype.simplify = function() { var t = this.buf; return 1 == t.length ? t[0] : this }, t
          }(),
          b = "…",
          w = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/,
          S = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;

        function T(t, e) { return t.length > e && (t = t.substring(0, e) + b), t }
        var E, D = function() {
            function t(e, n) { this.hexDigits = "0123456789ABCDEF", e instanceof t ? (this.enc = e.enc, this.pos = e.pos) : (this.enc = e, this.pos = n) }
            return t.prototype.get = function(t) { if (void 0 === t && (t = this.pos++), t >= this.enc.length) throw new Error("Requesting byte offset " + t + " on a stream of length " + this.enc.length); return "string" == typeof this.enc ? this.enc.charCodeAt(t) : this.enc[t] }, t.prototype.hexByte = function(t) { return this.hexDigits.charAt(t >> 4 & 15) + this.hexDigits.charAt(15 & t) }, t.prototype.hexDump = function(t, e, n) {
              for (var r = "", i = t; i < e; ++i)
                if (r += this.hexByte(this.get(i)), !0 !== n) switch (15 & i) {
                  case 7:
                    r += "  ";
                    break;
                  case 15:
                    r += "\n";
                    break;
                  default:
                    r += " "
                }
              return r
            }, t.prototype.isASCII = function(t, e) { for (var n = t; n < e; ++n) { var r = this.get(n); if (r < 32 || r > 176) return !1 } return !0 }, t.prototype.parseStringISO = function(t, e) { for (var n = "", r = t; r < e; ++r) n += String.fromCharCode(this.get(r)); return n }, t.prototype.parseStringUTF = function(t, e) {
              for (var n = "", r = t; r < e;) {
                var i = this.get(r++);
                n += i < 128 ? String.fromCharCode(i) : i > 191 && i < 224 ? String.fromCharCode((31 & i) << 6 | 63 & this.get(r++)) : String.fromCharCode((15 & i) << 12 | (63 & this.get(r++)) << 6 | 63 & this.get(r++))
              }
              return n
            }, t.prototype.parseStringBMP = function(t, e) { for (var n, r, i = "", o = t; o < e;) n = this.get(o++), r = this.get(o++), i += String.fromCharCode(n << 8 | r); return i }, t.prototype.parseTime = function(t, e, n) {
              var r = this.parseStringISO(t, e),
                i = (n ? w : S).exec(r);
              return i ? (n && (i[1] = +i[1], i[1] += +i[1] < 70 ? 2e3 : 1900), r = i[1] + "-" + i[2] + "-" + i[3] + " " + i[4], i[5] && (r += ":" + i[5], i[6] && (r += ":" + i[6], i[7] && (r += "." + i[7]))), i[8] && (r += " UTC", "Z" != i[8] && (r += i[8], i[9] && (r += ":" + i[9]))), r) : "Unrecognized time: " + r
            }, t.prototype.parseInteger = function(t, e) {
              for (var n, r = this.get(t), i = r > 127, o = i ? 255 : 0, s = ""; r == o && ++t < e;) r = this.get(t);
              if (0 == (n = e - t)) return i ? -1 : 0;
              if (n > 4) {
                for (s = r, n <<= 3; 0 == (128 & (+s ^ o));) s = +s << 1, --n;
                s = "(" + n + " bit)\n"
              }
              i && (r -= 256);
              for (var a = new y(r), u = t + 1; u < e; ++u) a.mulAdd(256, this.get(u));
              return s + a.toString()
            }, t.prototype.parseBitString = function(t, e, n) { for (var r = this.get(t), i = "(" + ((e - t - 1 << 3) - r) + " bit)\n", o = "", s = t + 1; s < e; ++s) { for (var a = this.get(s), u = s == e - 1 ? r : 0, h = 7; h >= u; --h) o += a >> h & 1 ? "1" : "0"; if (o.length > n) return i + T(o, n) } return i + o }, t.prototype.parseOctetString = function(t, e, n) {
              if (this.isASCII(t, e)) return T(this.parseStringISO(t, e), n);
              var r = e - t,
                i = "(" + r + " byte)\n";
              r > (n /= 2) && (e = t + n);
              for (var o = t; o < e; ++o) i += this.hexByte(this.get(o));
              return r > n && (i += b), i
            }, t.prototype.parseOID = function(t, e, n) {
              for (var r = "", i = new y, o = 0, s = t; s < e; ++s) {
                var a = this.get(s);
                if (i.mulAdd(128, 127 & a), o += 7, !(128 & a)) {
                  if ("" === r)
                    if ((i = i.simplify()) instanceof y) i.sub(80), r = "2." + i.toString();
                    else {
                      var u = i < 80 ? i < 40 ? 0 : 1 : 2;
                      r = u + "." + (i - 40 * u)
                    }
                  else r += "." + i.toString();
                  if (r.length > n) return T(r, n);
                  i = new y, o = 0
                }
              }
              return o > 0 && (r += ".incomplete"), r
            }, t
          }(),
          A = function() {
            function t(t, e, n, r, i) {
              if (!(r instanceof x)) throw new Error("Invalid tag value.");
              this.stream = t, this.header = e, this.length = n, this.tag = r, this.sub = i
            }
            return t.prototype.typeName = function() {
              switch (this.tag.tagClass) {
                case 0:
                  switch (this.tag.tagNumber) {
                    case 0:
                      return "EOC";
                    case 1:
                      return "BOOLEAN";
                    case 2:
                      return "INTEGER";
                    case 3:
                      return "BIT_STRING";
                    case 4:
                      return "OCTET_STRING";
                    case 5:
                      return "NULL";
                    case 6:
                      return "OBJECT_IDENTIFIER";
                    case 7:
                      return "ObjectDescriptor";
                    case 8:
                      return "EXTERNAL";
                    case 9:
                      return "REAL";
                    case 10:
                      return "ENUMERATED";
                    case 11:
                      return "EMBEDDED_PDV";
                    case 12:
                      return "UTF8String";
                    case 16:
                      return "SEQUENCE";
                    case 17:
                      return "SET";
                    case 18:
                      return "NumericString";
                    case 19:
                      return "PrintableString";
                    case 20:
                      return "TeletexString";
                    case 21:
                      return "VideotexString";
                    case 22:
                      return "IA5String";
                    case 23:
                      return "UTCTime";
                    case 24:
                      return "GeneralizedTime";
                    case 25:
                      return "GraphicString";
                    case 26:
                      return "VisibleString";
                    case 27:
                      return "GeneralString";
                    case 28:
                      return "UniversalString";
                    case 30:
                      return "BMPString"
                  }
                  return "Universal_" + this.tag.tagNumber.toString();
                case 1:
                  return "Application_" + this.tag.tagNumber.toString();
                case 2:
                  return "[" + this.tag.tagNumber.toString() + "]";
                case 3:
                  return "Private_" + this.tag.tagNumber.toString()
              }
            }, t.prototype.content = function(t) {
              if (void 0 === this.tag) return null;
              void 0 === t && (t = 1 / 0);
              var e = this.posContent(),
                n = Math.abs(this.length);
              if (!this.tag.isUniversal()) return null !== this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(e, e + n, t);
              switch (this.tag.tagNumber) {
                case 1:
                  return 0 === this.stream.get(e) ? "false" : "true";
                case 2:
                  return this.stream.parseInteger(e, e + n);
                case 3:
                  return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(e, e + n, t);
                case 4:
                  return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(e, e + n, t);
                case 6:
                  return this.stream.parseOID(e, e + n, t);
                case 16:
                case 17:
                  return null !== this.sub ? "(" + this.sub.length + " elem)" : "(no elem)";
                case 12:
                  return T(this.stream.parseStringUTF(e, e + n), t);
                case 18:
                case 19:
                case 20:
                case 21:
                case 22:
                case 26:
                  return T(this.stream.parseStringISO(e, e + n), t);
                case 30:
                  return T(this.stream.parseStringBMP(e, e + n), t);
                case 23:
                case 24:
                  return this.stream.parseTime(e, e + n, 23 == this.tag.tagNumber)
              }
              return null
            }, t.prototype.toString = function() { return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (null === this.sub ? "null" : this.sub.length) + "]" }, t.prototype.toPrettyString = function(t) { void 0 === t && (t = ""); var e = t + this.typeName() + " @" + this.stream.pos; if (this.length >= 0 && (e += "+"), e += this.length, this.tag.tagConstructed ? e += " (constructed)" : !this.tag.isUniversal() || 3 != this.tag.tagNumber && 4 != this.tag.tagNumber || null === this.sub || (e += " (encapsulates)"), e += "\n", null !== this.sub) { t += "  "; for (var n = 0, r = this.sub.length; n < r; ++n) e += this.sub[n].toPrettyString(t) } return e }, t.prototype.posStart = function() { return this.stream.pos }, t.prototype.posContent = function() { return this.stream.pos + this.header }, t.prototype.posEnd = function() { return this.stream.pos + this.header + Math.abs(this.length) }, t.prototype.toHexString = function() { return this.stream.hexDump(this.posStart(), this.posEnd(), !0) }, t.decodeLength = function(t) {
              var e = t.get(),
                n = 127 & e;
              if (n == e) return n;
              if (n > 6) throw new Error("Length over 48 bits not supported at position " + (t.pos - 1));
              if (0 === n) return null;
              e = 0;
              for (var r = 0; r < n; ++r) e = 256 * e + t.get();
              return e
            }, t.prototype.getHexStringValue = function() {
              var t = this.toHexString(),
                e = 2 * this.header,
                n = 2 * this.length;
              return t.substr(e, n)
            }, t.decode = function(e) {
              var n;
              n = e instanceof D ? e : new D(e, 0);
              var r = new D(n),
                i = new x(n),
                o = t.decodeLength(n),
                s = n.pos,
                a = s - r.pos,
                u = null,
                h = function() {
                  var e = [];
                  if (null !== o) { for (var r = s + o; n.pos < r;) e[e.length] = t.decode(n); if (n.pos != r) throw new Error("Content size is not correct for container starting at offset " + s) } else try {
                    for (;;) {
                      var i = t.decode(n);
                      if (i.tag.isEOC()) break;
                      e[e.length] = i
                    }
                    o = s - n.pos
                  } catch (t) { throw new Error("Exception while decoding undefined length content: " + t) }
                  return e
                };
              if (i.tagConstructed) u = h();
              else if (i.isUniversal() && (3 == i.tagNumber || 4 == i.tagNumber)) try {
                if (3 == i.tagNumber && 0 != n.get()) throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
                u = h();
                for (var c = 0; c < u.length; ++c)
                  if (u[c].tag.isEOC()) throw new Error("EOC is not supposed to be actual content.")
              } catch (t) { u = null }
              if (null === u) {
                if (null === o) throw new Error("We can't skip over an invalid tag with undefined length at offset " + s);
                n.pos = s + Math.abs(o)
              }
              return new t(r, a, o, i, u)
            }, t
          }(),
          x = function() {
            function t(t) {
              var e = t.get();
              if (this.tagClass = e >> 6, this.tagConstructed = 0 != (32 & e), this.tagNumber = 31 & e, 31 == this.tagNumber) {
                var n = new y;
                do { e = t.get(), n.mulAdd(128, 127 & e) } while (128 & e);
                this.tagNumber = n.simplify()
              }
            }
            return t.prototype.isUniversal = function() { return 0 === this.tagClass }, t.prototype.isEOC = function() { return 0 === this.tagClass && 0 === this.tagNumber }, t
          }(),
          I = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
          R = (1 << 26) / I[I.length - 1],
          k = function() {
            function t(t, e, n) { null != t && ("number" == typeof t ? this.fromNumber(t, e, n) : null == e && "string" != typeof t ? this.fromString(t, 256) : this.fromString(t, e)) }
            return t.prototype.toString = function(t) {
              if (this.s < 0) return "-" + this.negate().toString(t);
              var e;
              if (16 == t) e = 4;
              else if (8 == t) e = 3;
              else if (2 == t) e = 1;
              else if (32 == t) e = 5;
              else {
                if (4 != t) return this.toRadix(t);
                e = 2
              }
              var r, i = (1 << e) - 1,
                o = !1,
                s = "",
                a = this.t,
                u = this.DB - a * this.DB % e;
              if (a-- > 0)
                for (u < this.DB && (r = this[a] >> u) > 0 && (o = !0, s = n(r)); a >= 0;) u < e ? (r = (this[a] & (1 << u) - 1) << e - u, r |= this[--a] >> (u += this.DB - e)) : (r = this[a] >> (u -= e) & i, u <= 0 && (u += this.DB, --a)), r > 0 && (o = !0), o && (s += n(r));
              return o ? s : "0"
            }, t.prototype.negate = function() { var e = M(); return t.ZERO.subTo(this, e), e }, t.prototype.abs = function() { return this.s < 0 ? this.negate() : this }, t.prototype.compareTo = function(t) {
              var e = this.s - t.s;
              if (0 != e) return e;
              var n = this.t;
              if (0 != (e = n - t.t)) return this.s < 0 ? -e : e;
              for (; --n >= 0;)
                if (0 != (e = this[n] - t[n])) return e;
              return 0
            }, t.prototype.bitLength = function() { return this.t <= 0 ? 0 : this.DB * (this.t - 1) + q(this[this.t - 1] ^ this.s & this.DM) }, t.prototype.mod = function(e) { var n = M(); return this.abs().divRemTo(e, null, n), this.s < 0 && n.compareTo(t.ZERO) > 0 && e.subTo(n, n), n }, t.prototype.modPowInt = function(t, e) { var n; return n = t < 256 || e.isEven() ? new O(e) : new C(e), this.exp(t, n) }, t.prototype.clone = function() { var t = M(); return this.copyTo(t), t }, t.prototype.intValue = function() { if (this.s < 0) { if (1 == this.t) return this[0] - this.DV; if (0 == this.t) return -1 } else { if (1 == this.t) return this[0]; if (0 == this.t) return 0 } return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0] }, t.prototype.byteValue = function() { return 0 == this.t ? this.s : this[0] << 24 >> 24 }, t.prototype.shortValue = function() { return 0 == this.t ? this.s : this[0] << 16 >> 16 }, t.prototype.signum = function() { return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1 }, t.prototype.toByteArray = function() {
              var t = this.t,
                e = [];
              e[0] = this.s;
              var n, r = this.DB - t * this.DB % 8,
                i = 0;
              if (t-- > 0)
                for (r < this.DB && (n = this[t] >> r) != (this.s & this.DM) >> r && (e[i++] = n | this.s << this.DB - r); t >= 0;) r < 8 ? (n = (this[t] & (1 << r) - 1) << 8 - r, n |= this[--t] >> (r += this.DB - 8)) : (n = this[t] >> (r -= 8) & 255, r <= 0 && (r += this.DB, --t)), 0 != (128 & n) && (n |= -256), 0 == i && (128 & this.s) != (128 & n) && ++i, (i > 0 || n != this.s) && (e[i++] = n);
              return e
            }, t.prototype.equals = function(t) { return 0 == this.compareTo(t) }, t.prototype.min = function(t) { return this.compareTo(t) < 0 ? this : t }, t.prototype.max = function(t) { return this.compareTo(t) > 0 ? this : t }, t.prototype.and = function(t) { var e = M(); return this.bitwiseTo(t, r, e), e }, t.prototype.or = function(t) { var e = M(); return this.bitwiseTo(t, i, e), e }, t.prototype.xor = function(t) { var e = M(); return this.bitwiseTo(t, o, e), e }, t.prototype.andNot = function(t) { var e = M(); return this.bitwiseTo(t, s, e), e }, t.prototype.not = function() { for (var t = M(), e = 0; e < this.t; ++e) t[e] = this.DM & ~this[e]; return t.t = this.t, t.s = ~this.s, t }, t.prototype.shiftLeft = function(t) { var e = M(); return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e }, t.prototype.shiftRight = function(t) { var e = M(); return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e }, t.prototype.getLowestSetBit = function() {
              for (var t = 0; t < this.t; ++t)
                if (0 != this[t]) return t * this.DB + a(this[t]);
              return this.s < 0 ? this.t * this.DB : -1
            }, t.prototype.bitCount = function() { for (var t = 0, e = this.s & this.DM, n = 0; n < this.t; ++n) t += u(this[n] ^ e); return t }, t.prototype.testBit = function(t) { var e = Math.floor(t / this.DB); return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB) }, t.prototype.setBit = function(t) { return this.changeBit(t, i) }, t.prototype.clearBit = function(t) { return this.changeBit(t, s) }, t.prototype.flipBit = function(t) { return this.changeBit(t, o) }, t.prototype.add = function(t) { var e = M(); return this.addTo(t, e), e }, t.prototype.subtract = function(t) { var e = M(); return this.subTo(t, e), e }, t.prototype.multiply = function(t) { var e = M(); return this.multiplyTo(t, e), e }, t.prototype.divide = function(t) { var e = M(); return this.divRemTo(t, e, null), e }, t.prototype.remainder = function(t) { var e = M(); return this.divRemTo(t, null, e), e }, t.prototype.divideAndRemainder = function(t) {
              var e = M(),
                n = M();
              return this.divRemTo(t, e, n), [e, n]
            }, t.prototype.modPow = function(t, e) {
              var n, r, i = t.bitLength(),
                o = H(1);
              if (i <= 0) return o;
              n = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6, r = i < 8 ? new O(e) : e.isEven() ? new N(e) : new C(e);
              var s = [],
                a = 3,
                u = n - 1,
                h = (1 << n) - 1;
              if (s[1] = r.convert(this), n > 1) { var c = M(); for (r.sqrTo(s[1], c); a <= h;) s[a] = M(), r.mulTo(c, s[a - 2], s[a]), a += 2 }
              var l, f, d = t.t - 1,
                p = !0,
                g = M();
              for (i = q(t[d]) - 1; d >= 0;) {
                for (i >= u ? l = t[d] >> i - u & h : (l = (t[d] & (1 << i + 1) - 1) << u - i, d > 0 && (l |= t[d - 1] >> this.DB + i - u)), a = n; 0 == (1 & l);) l >>= 1, --a;
                if ((i -= a) < 0 && (i += this.DB, --d), p) s[l].copyTo(o), p = !1;
                else {
                  for (; a > 1;) r.sqrTo(o, g), r.sqrTo(g, o), a -= 2;
                  a > 0 ? r.sqrTo(o, g) : (f = o, o = g, g = f), r.mulTo(g, s[l], o)
                }
                for (; d >= 0 && 0 == (t[d] & 1 << i);) r.sqrTo(o, g), f = o, o = g, g = f, --i < 0 && (i = this.DB - 1, --d)
              }
              return r.revert(o)
            }, t.prototype.modInverse = function(e) {
              var n = e.isEven();
              if (this.isEven() && n || 0 == e.signum()) return t.ZERO;
              for (var r = e.clone(), i = this.clone(), o = H(1), s = H(0), a = H(0), u = H(1); 0 != r.signum();) {
                for (; r.isEven();) r.rShiftTo(1, r), n ? (o.isEven() && s.isEven() || (o.addTo(this, o), s.subTo(e, s)), o.rShiftTo(1, o)) : s.isEven() || s.subTo(e, s), s.rShiftTo(1, s);
                for (; i.isEven();) i.rShiftTo(1, i), n ? (a.isEven() && u.isEven() || (a.addTo(this, a), u.subTo(e, u)), a.rShiftTo(1, a)) : u.isEven() || u.subTo(e, u), u.rShiftTo(1, u);
                r.compareTo(i) >= 0 ? (r.subTo(i, r), n && o.subTo(a, o), s.subTo(u, s)) : (i.subTo(r, i), n && a.subTo(o, a), u.subTo(s, u))
              }
              return 0 != i.compareTo(t.ONE) ? t.ZERO : u.compareTo(e) >= 0 ? u.subtract(e) : u.signum() < 0 ? (u.addTo(e, u), u.signum() < 0 ? u.add(e) : u) : u
            }, t.prototype.pow = function(t) { return this.exp(t, new B) }, t.prototype.gcd = function(t) {
              var e = this.s < 0 ? this.negate() : this.clone(),
                n = t.s < 0 ? t.negate() : t.clone();
              if (e.compareTo(n) < 0) {
                var r = e;
                e = n, n = r
              }
              var i = e.getLowestSetBit(),
                o = n.getLowestSetBit();
              if (o < 0) return e;
              for (i < o && (o = i), o > 0 && (e.rShiftTo(o, e), n.rShiftTo(o, n)); e.signum() > 0;)(i = e.getLowestSetBit()) > 0 && e.rShiftTo(i, e), (i = n.getLowestSetBit()) > 0 && n.rShiftTo(i, n), e.compareTo(n) >= 0 ? (e.subTo(n, e), e.rShiftTo(1, e)) : (n.subTo(e, n), n.rShiftTo(1, n));
              return o > 0 && n.lShiftTo(o, n), n
            }, t.prototype.isProbablePrime = function(t) {
              var e, n = this.abs();
              if (1 == n.t && n[0] <= I[I.length - 1]) {
                for (e = 0; e < I.length; ++e)
                  if (n[0] == I[e]) return !0;
                return !1
              }
              if (n.isEven()) return !1;
              for (e = 1; e < I.length;) {
                for (var r = I[e], i = e + 1; i < I.length && r < R;) r *= I[i++];
                for (r = n.modInt(r); e < i;)
                  if (r % I[e++] == 0) return !1
              }
              return n.millerRabin(t)
            }, t.prototype.copyTo = function(t) {
              for (var e = this.t - 1; e >= 0; --e) t[e] = this[e];
              t.t = this.t, t.s = this.s
            }, t.prototype.fromInt = function(t) { this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0 }, t.prototype.fromString = function(e, n) {
              var r;
              if (16 == n) r = 4;
              else if (8 == n) r = 3;
              else if (256 == n) r = 8;
              else if (2 == n) r = 1;
              else if (32 == n) r = 5;
              else {
                if (4 != n) return void this.fromRadix(e, n);
                r = 2
              }
              this.t = 0, this.s = 0;
              for (var i = e.length, o = !1, s = 0; --i >= 0;) {
                var a = 8 == r ? 255 & +e[i] : j(e, i);
                a < 0 ? "-" == e.charAt(i) && (o = !0) : (o = !1, 0 == s ? this[this.t++] = a : s + r > this.DB ? (this[this.t - 1] |= (a & (1 << this.DB - s) - 1) << s, this[this.t++] = a >> this.DB - s) : this[this.t - 1] |= a << s, (s += r) >= this.DB && (s -= this.DB))
              }
              8 == r && 0 != (128 & +e[0]) && (this.s = -1, s > 0 && (this[this.t - 1] |= (1 << this.DB - s) - 1 << s)), this.clamp(), o && t.ZERO.subTo(this, this)
            }, t.prototype.clamp = function() { for (var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;) --this.t }, t.prototype.dlShiftTo = function(t, e) {
              var n;
              for (n = this.t - 1; n >= 0; --n) e[n + t] = this[n];
              for (n = t - 1; n >= 0; --n) e[n] = 0;
              e.t = this.t + t, e.s = this.s
            }, t.prototype.drShiftTo = function(t, e) {
              for (var n = t; n < this.t; ++n) e[n - t] = this[n];
              e.t = Math.max(this.t - t, 0), e.s = this.s
            }, t.prototype.lShiftTo = function(t, e) {
              for (var n = t % this.DB, r = this.DB - n, i = (1 << r) - 1, o = Math.floor(t / this.DB), s = this.s << n & this.DM, a = this.t - 1; a >= 0; --a) e[a + o + 1] = this[a] >> r | s, s = (this[a] & i) << n;
              for (a = o - 1; a >= 0; --a) e[a] = 0;
              e[o] = s, e.t = this.t + o + 1, e.s = this.s, e.clamp()
            }, t.prototype.rShiftTo = function(t, e) {
              e.s = this.s;
              var n = Math.floor(t / this.DB);
              if (n >= this.t) e.t = 0;
              else {
                var r = t % this.DB,
                  i = this.DB - r,
                  o = (1 << r) - 1;
                e[0] = this[n] >> r;
                for (var s = n + 1; s < this.t; ++s) e[s - n - 1] |= (this[s] & o) << i, e[s - n] = this[s] >> r;
                r > 0 && (e[this.t - n - 1] |= (this.s & o) << i), e.t = this.t - n, e.clamp()
              }
            }, t.prototype.subTo = function(t, e) {
              for (var n = 0, r = 0, i = Math.min(t.t, this.t); n < i;) r += this[n] - t[n], e[n++] = r & this.DM, r >>= this.DB;
              if (t.t < this.t) {
                for (r -= t.s; n < this.t;) r += this[n], e[n++] = r & this.DM, r >>= this.DB;
                r += this.s
              } else {
                for (r += this.s; n < t.t;) r -= t[n], e[n++] = r & this.DM, r >>= this.DB;
                r -= t.s
              }
              e.s = r < 0 ? -1 : 0, r < -1 ? e[n++] = this.DV + r : r > 0 && (e[n++] = r), e.t = n, e.clamp()
            }, t.prototype.multiplyTo = function(e, n) {
              var r = this.abs(),
                i = e.abs(),
                o = r.t;
              for (n.t = o + i.t; --o >= 0;) n[o] = 0;
              for (o = 0; o < i.t; ++o) n[o + r.t] = r.am(0, i[o], n, o, 0, r.t);
              n.s = 0, n.clamp(), this.s != e.s && t.ZERO.subTo(n, n)
            }, t.prototype.squareTo = function(t) {
              for (var e = this.abs(), n = t.t = 2 * e.t; --n >= 0;) t[n] = 0;
              for (n = 0; n < e.t - 1; ++n) {
                var r = e.am(n, e[n], t, 2 * n, 0, 1);
                (t[n + e.t] += e.am(n + 1, 2 * e[n], t, 2 * n + 1, r, e.t - n - 1)) >= e.DV && (t[n + e.t] -= e.DV, t[n + e.t + 1] = 1)
              }
              t.t > 0 && (t[t.t - 1] += e.am(n, e[n], t, 2 * n, 0, 1)), t.s = 0, t.clamp()
            }, t.prototype.divRemTo = function(e, n, r) {
              var i = e.abs();
              if (!(i.t <= 0)) {
                var o = this.abs();
                if (o.t < i.t) return null != n && n.fromInt(0), void(null != r && this.copyTo(r));
                null == r && (r = M());
                var s = M(),
                  a = this.s,
                  u = e.s,
                  h = this.DB - q(i[i.t - 1]);
                h > 0 ? (i.lShiftTo(h, s), o.lShiftTo(h, r)) : (i.copyTo(s), o.copyTo(r));
                var c = s.t,
                  l = s[c - 1];
                if (0 != l) {
                  var f = l * (1 << this.F1) + (c > 1 ? s[c - 2] >> this.F2 : 0),
                    d = this.FV / f,
                    p = (1 << this.F1) / f,
                    g = 1 << this.F2,
                    m = r.t,
                    v = m - c,
                    y = null == n ? M() : n;
                  for (s.dlShiftTo(v, y), r.compareTo(y) >= 0 && (r[r.t++] = 1, r.subTo(y, r)), t.ONE.dlShiftTo(c, y), y.subTo(s, s); s.t < c;) s[s.t++] = 0;
                  for (; --v >= 0;) {
                    var b = r[--m] == l ? this.DM : Math.floor(r[m] * d + (r[m - 1] + g) * p);
                    if ((r[m] += s.am(0, b, r, v, 0, c)) < b)
                      for (s.dlShiftTo(v, y), r.subTo(y, r); r[m] < --b;) r.subTo(y, r)
                  }
                  null != n && (r.drShiftTo(c, n), a != u && t.ZERO.subTo(n, n)), r.t = c, r.clamp(), h > 0 && r.rShiftTo(h, r), a < 0 && t.ZERO.subTo(r, r)
                }
              }
            }, t.prototype.invDigit = function() { if (this.t < 1) return 0; var t = this[0]; if (0 == (1 & t)) return 0; var e = 3 & t; return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e }, t.prototype.isEven = function() { return 0 == (this.t > 0 ? 1 & this[0] : this.s) }, t.prototype.exp = function(e, n) {
              if (e > 4294967295 || e < 1) return t.ONE;
              var r = M(),
                i = M(),
                o = n.convert(this),
                s = q(e) - 1;
              for (o.copyTo(r); --s >= 0;)
                if (n.sqrTo(r, i), (e & 1 << s) > 0) n.mulTo(i, o, r);
                else {
                  var a = r;
                  r = i, i = a
                }
              return n.revert(r)
            }, t.prototype.chunkSize = function(t) { return Math.floor(Math.LN2 * this.DB / Math.log(t)) }, t.prototype.toRadix = function(t) {
              if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
              var e = this.chunkSize(t),
                n = Math.pow(t, e),
                r = H(n),
                i = M(),
                o = M(),
                s = "";
              for (this.divRemTo(r, i, o); i.signum() > 0;) s = (n + o.intValue()).toString(t).substr(1) + s, i.divRemTo(r, i, o);
              return o.intValue().toString(t) + s
            }, t.prototype.fromRadix = function(e, n) {
              this.fromInt(0), null == n && (n = 10);
              for (var r = this.chunkSize(n), i = Math.pow(n, r), o = !1, s = 0, a = 0, u = 0; u < e.length; ++u) {
                var h = j(e, u);
                h < 0 ? "-" == e.charAt(u) && 0 == this.signum() && (o = !0) : (a = n * a + h, ++s >= r && (this.dMultiply(i), this.dAddOffset(a, 0), s = 0, a = 0))
              }
              s > 0 && (this.dMultiply(Math.pow(n, s)), this.dAddOffset(a, 0)), o && t.ZERO.subTo(this, this)
            }, t.prototype.fromNumber = function(e, n, r) {
              if ("number" == typeof n)
                if (e < 2) this.fromInt(1);
                else
                  for (this.fromNumber(e, r), this.testBit(e - 1) || this.bitwiseTo(t.ONE.shiftLeft(e - 1), i, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(n);) this.dAddOffset(2, 0), this.bitLength() > e && this.subTo(t.ONE.shiftLeft(e - 1), this);
              else {
                var o = [],
                  s = 7 & e;
                o.length = 1 + (e >> 3), n.nextBytes(o), s > 0 ? o[0] &= (1 << s) - 1 : o[0] = 0, this.fromString(o, 256)
              }
            }, t.prototype.bitwiseTo = function(t, e, n) {
              var r, i, o = Math.min(t.t, this.t);
              for (r = 0; r < o; ++r) n[r] = e(this[r], t[r]);
              if (t.t < this.t) {
                for (i = t.s & this.DM, r = o; r < this.t; ++r) n[r] = e(this[r], i);
                n.t = this.t
              } else {
                for (i = this.s & this.DM, r = o; r < t.t; ++r) n[r] = e(i, t[r]);
                n.t = t.t
              }
              n.s = e(this.s, t.s), n.clamp()
            }, t.prototype.changeBit = function(e, n) { var r = t.ONE.shiftLeft(e); return this.bitwiseTo(r, n, r), r }, t.prototype.addTo = function(t, e) {
              for (var n = 0, r = 0, i = Math.min(t.t, this.t); n < i;) r += this[n] + t[n], e[n++] = r & this.DM, r >>= this.DB;
              if (t.t < this.t) {
                for (r += t.s; n < this.t;) r += this[n], e[n++] = r & this.DM, r >>= this.DB;
                r += this.s
              } else {
                for (r += this.s; n < t.t;) r += t[n], e[n++] = r & this.DM, r >>= this.DB;
                r += t.s
              }
              e.s = r < 0 ? -1 : 0, r > 0 ? e[n++] = r : r < -1 && (e[n++] = this.DV + r), e.t = n, e.clamp()
            }, t.prototype.dMultiply = function(t) { this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp() }, t.prototype.dAddOffset = function(t, e) { if (0 != t) { for (; this.t <= e;) this[this.t++] = 0; for (this[e] += t; this[e] >= this.DV;) this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e] } }, t.prototype.multiplyLowerTo = function(t, e, n) {
              var r = Math.min(this.t + t.t, e);
              for (n.s = 0, n.t = r; r > 0;) n[--r] = 0;
              for (var i = n.t - this.t; r < i; ++r) n[r + this.t] = this.am(0, t[r], n, r, 0, this.t);
              for (i = Math.min(t.t, e); r < i; ++r) this.am(0, t[r], n, r, 0, e - r);
              n.clamp()
            }, t.prototype.multiplyUpperTo = function(t, e, n) {
              --e;
              var r = n.t = this.t + t.t - e;
              for (n.s = 0; --r >= 0;) n[r] = 0;
              for (r = Math.max(e - this.t, 0); r < t.t; ++r) n[this.t + r - e] = this.am(e - r, t[r], n, 0, 0, this.t + r - e);
              n.clamp(), n.drShiftTo(1, n)
            }, t.prototype.modInt = function(t) {
              if (t <= 0) return 0;
              var e = this.DV % t,
                n = this.s < 0 ? t - 1 : 0;
              if (this.t > 0)
                if (0 == e) n = this[0] % t;
                else
                  for (var r = this.t - 1; r >= 0; --r) n = (e * n + this[r]) % t;
              return n
            }, t.prototype.millerRabin = function(e) {
              var n = this.subtract(t.ONE),
                r = n.getLowestSetBit();
              if (r <= 0) return !1;
              var i = n.shiftRight(r);
              (e = e + 1 >> 1) > I.length && (e = I.length);
              for (var o = M(), s = 0; s < e; ++s) {
                o.fromInt(I[Math.floor(Math.random() * I.length)]);
                var a = o.modPow(i, this);
                if (0 != a.compareTo(t.ONE) && 0 != a.compareTo(n)) {
                  for (var u = 1; u++ < r && 0 != a.compareTo(n);)
                    if (0 == (a = a.modPowInt(2, this)).compareTo(t.ONE)) return !1;
                  if (0 != a.compareTo(n)) return !1
                }
              }
              return !0
            }, t.prototype.square = function() { var t = M(); return this.squareTo(t), t }, t.prototype.gcda = function(t, e) {
              var n = this.s < 0 ? this.negate() : this.clone(),
                r = t.s < 0 ? t.negate() : t.clone();
              if (n.compareTo(r) < 0) {
                var i = n;
                n = r, r = i
              }
              var o = n.getLowestSetBit(),
                s = r.getLowestSetBit();
              if (s < 0) e(n);
              else {
                o < s && (s = o), s > 0 && (n.rShiftTo(s, n), r.rShiftTo(s, r));
                var a = function() {
                  (o = n.getLowestSetBit()) > 0 && n.rShiftTo(o, n), (o = r.getLowestSetBit()) > 0 && r.rShiftTo(o, r), n.compareTo(r) >= 0 ? (n.subTo(r, n), n.rShiftTo(1, n)) : (r.subTo(n, r), r.rShiftTo(1, r)), n.signum() > 0 ? setTimeout(a, 0) : (s > 0 && r.lShiftTo(s, r), setTimeout(function() { e(r) }, 0))
                };
                setTimeout(a, 10)
              }
            }, t.prototype.fromNumberAsync = function(e, n, r, o) {
              if ("number" == typeof n)
                if (e < 2) this.fromInt(1);
                else {
                  this.fromNumber(e, r), this.testBit(e - 1) || this.bitwiseTo(t.ONE.shiftLeft(e - 1), i, this), this.isEven() && this.dAddOffset(1, 0);
                  var s = this,
                    a = function() { s.dAddOffset(2, 0), s.bitLength() > e && s.subTo(t.ONE.shiftLeft(e - 1), s), s.isProbablePrime(n) ? setTimeout(function() { o() }, 0) : setTimeout(a, 0) };
                  setTimeout(a, 0)
                }
              else {
                var u = [],
                  h = 7 & e;
                u.length = 1 + (e >> 3), n.nextBytes(u), h > 0 ? u[0] &= (1 << h) - 1 : u[0] = 0, this.fromString(u, 256)
              }
            }, t
          }(),
          B = function() {
            function t() {}
            return t.prototype.convert = function(t) { return t }, t.prototype.revert = function(t) { return t }, t.prototype.mulTo = function(t, e, n) { t.multiplyTo(e, n) }, t.prototype.sqrTo = function(t, e) { t.squareTo(e) }, t
          }(),
          O = function() {
            function t(t) { this.m = t }
            return t.prototype.convert = function(t) { return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t }, t.prototype.revert = function(t) { return t }, t.prototype.reduce = function(t) { t.divRemTo(this.m, null, t) }, t.prototype.mulTo = function(t, e, n) { t.multiplyTo(e, n), this.reduce(n) }, t.prototype.sqrTo = function(t, e) { t.squareTo(e), this.reduce(e) }, t
          }(),
          C = function() {
            function t(t) { this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t }
            return t.prototype.convert = function(t) { var e = M(); return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(k.ZERO) > 0 && this.m.subTo(e, e), e }, t.prototype.revert = function(t) { var e = M(); return t.copyTo(e), this.reduce(e), e }, t.prototype.reduce = function(t) {
              for (; t.t <= this.mt2;) t[t.t++] = 0;
              for (var e = 0; e < this.m.t; ++e) {
                var n = 32767 & t[e],
                  r = n * this.mpl + ((n * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
                for (t[n = e + this.m.t] += this.m.am(0, r, t, e, 0, this.m.t); t[n] >= t.DV;) t[n] -= t.DV, t[++n]++
              }
              t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t)
            }, t.prototype.mulTo = function(t, e, n) { t.multiplyTo(e, n), this.reduce(n) }, t.prototype.sqrTo = function(t, e) { t.squareTo(e), this.reduce(e) }, t
          }(),
          N = function() {
            function t(t) { this.m = t, this.r2 = M(), this.q3 = M(), k.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t) }
            return t.prototype.convert = function(t) { if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m); if (t.compareTo(this.m) < 0) return t; var e = M(); return t.copyTo(e), this.reduce(e), e }, t.prototype.revert = function(t) { return t }, t.prototype.reduce = function(t) { for (t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;) t.dAddOffset(1, this.m.t + 1); for (t.subTo(this.r2, t); t.compareTo(this.m) >= 0;) t.subTo(this.m, t) }, t.prototype.mulTo = function(t, e, n) { t.multiplyTo(e, n), this.reduce(n) }, t.prototype.sqrTo = function(t, e) { t.squareTo(e), this.reduce(e) }, t
          }();

        function M() { return new k(null) }

        function P(t, e) { return new k(t, e) }
        "Microsoft Internet Explorer" == navigator.appName ? (k.prototype.am = function(t, e, n, r, i, o) {
          for (var s = 32767 & e, a = e >> 15; --o >= 0;) {
            var u = 32767 & this[t],
              h = this[t++] >> 15,
              c = a * u + h * s;
            i = ((u = s * u + ((32767 & c) << 15) + n[r] + (1073741823 & i)) >>> 30) + (c >>> 15) + a * h + (i >>> 30), n[r++] = 1073741823 & u
          }
          return i
        }, E = 30) : "Netscape" != navigator.appName ? (k.prototype.am = function(t, e, n, r, i, o) {
          for (; --o >= 0;) {
            var s = e * this[t++] + n[r] + i;
            i = Math.floor(s / 67108864), n[r++] = 67108863 & s
          }
          return i
        }, E = 26) : (k.prototype.am = function(t, e, n, r, i, o) {
          for (var s = 16383 & e, a = e >> 14; --o >= 0;) {
            var u = 16383 & this[t],
              h = this[t++] >> 14,
              c = a * u + h * s;
            i = ((u = s * u + ((16383 & c) << 14) + n[r] + i) >> 28) + (c >> 14) + a * h, n[r++] = 268435455 & u
          }
          return i
        }, E = 28), k.prototype.DB = E, k.prototype.DM = (1 << E) - 1, k.prototype.DV = 1 << E, k.prototype.FV = Math.pow(2, 52), k.prototype.F1 = 52 - E, k.prototype.F2 = 2 * E - 52;
        var V, L, _ = [];
        for (V = "0".charCodeAt(0), L = 0; L <= 9; ++L) _[V++] = L;
        for (V = "a".charCodeAt(0), L = 10; L < 36; ++L) _[V++] = L;
        for (V = "A".charCodeAt(0), L = 10; L < 36; ++L) _[V++] = L;

        function j(t, e) { var n = _[t.charCodeAt(e)]; return null == n ? -1 : n }

        function H(t) { var e = M(); return e.fromInt(t), e }

        function q(t) { var e, n = 1; return 0 != (e = t >>> 16) && (t = e, n += 16), 0 != (e = t >> 8) && (t = e, n += 8), 0 != (e = t >> 4) && (t = e, n += 4), 0 != (e = t >> 2) && (t = e, n += 2), 0 != (e = t >> 1) && (t = e, n += 1), n }
        k.ZERO = H(0), k.ONE = H(1);
        var F, U, z = function() {
            function t() { this.i = 0, this.j = 0, this.S = [] }
            return t.prototype.init = function(t) {
              var e, n, r;
              for (e = 0; e < 256; ++e) this.S[e] = e;
              for (n = 0, e = 0; e < 256; ++e) n = n + this.S[e] + t[e % t.length] & 255, r = this.S[e], this.S[e] = this.S[n], this.S[n] = r;
              this.i = 0, this.j = 0
            }, t.prototype.next = function() { var t; return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255] }, t
          }(),
          K = 256,
          G = null;
        if (null == G) {
          G = [], U = 0;
          var Y = void 0;
          if (window.crypto && window.crypto.getRandomValues) { var X = new Uint32Array(256); for (window.crypto.getRandomValues(X), Y = 0; Y < X.length; ++Y) G[U++] = 255 & X[Y] }
          var $ = function(t) {
            if (this.count = this.count || 0, this.count >= 256 || U >= K) window.removeEventListener ? window.removeEventListener("mousemove", $, !1) : window.detachEvent && window.detachEvent("onmousemove", $);
            else try {
              var e = t.x + t.y;
              G[U++] = 255 & e, this.count += 1
            } catch (t) {}
          };
          window.addEventListener ? window.addEventListener("mousemove", $, !1) : window.attachEvent && window.attachEvent("onmousemove", $)
        }

        function Z() {
          if (null == F) {
            for (F = new z; U < K;) {
              var t = Math.floor(65536 * Math.random());
              G[U++] = 255 & t
            }
            for (F.init(G), U = 0; U < G.length; ++U) G[U] = 0;
            U = 0
          }
          return F.next()
        }
        var J = function() {
            function t() {}
            return t.prototype.nextBytes = function(t) { for (var e = 0; e < t.length; ++e) t[e] = Z() }, t
          }(),
          W = function() {
            function t() { this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null }
            return t.prototype.doPublic = function(t) { return t.modPowInt(this.e, this.n) }, t.prototype.doPrivate = function(t) { if (null == this.p || null == this.q) return t.modPow(this.d, this.n); for (var e = t.mod(this.p).modPow(this.dmp1, this.p), n = t.mod(this.q).modPow(this.dmq1, this.q); e.compareTo(n) < 0;) e = e.add(this.p); return e.subtract(n).multiply(this.coeff).mod(this.p).multiply(this.q).add(n) }, t.prototype.setPublic = function(t, e) { null != t && null != e && t.length > 0 && e.length > 0 ? (this.n = P(t, 16), this.e = parseInt(e, 16)) : console.error("Invalid RSA public key") }, t.prototype.encrypt = function(t) {
              var e = function(t, e) {
                if (e < t.length + 11) return console.error("Message too long for RSA"), null;
                for (var n = [], r = t.length - 1; r >= 0 && e > 0;) {
                  var i = t.charCodeAt(r--);
                  i < 128 ? n[--e] = i : i > 127 && i < 2048 ? (n[--e] = 63 & i | 128, n[--e] = i >> 6 | 192) : (n[--e] = 63 & i | 128, n[--e] = i >> 6 & 63 | 128, n[--e] = i >> 12 | 224)
                }
                n[--e] = 0;
                for (var o = new J, s = []; e > 2;) {
                  for (s[0] = 0; 0 == s[0];) o.nextBytes(s);
                  n[--e] = s[0]
                }
                return n[--e] = 2, n[--e] = 0, new k(n)
              }(t, this.n.bitLength() + 7 >> 3);
              if (null == e) return null;
              var n = this.doPublic(e);
              if (null == n) return null;
              var r = n.toString(16);
              return 0 == (1 & r.length) ? r : "0" + r
            }, t.prototype.setPrivate = function(t, e, n) { null != t && null != e && t.length > 0 && e.length > 0 ? (this.n = P(t, 16), this.e = parseInt(e, 16), this.d = P(n, 16)) : console.error("Invalid RSA private key") }, t.prototype.setPrivateEx = function(t, e, n, r, i, o, s, a) { null != t && null != e && t.length > 0 && e.length > 0 ? (this.n = P(t, 16), this.e = parseInt(e, 16), this.d = P(n, 16), this.p = P(r, 16), this.q = P(i, 16), this.dmp1 = P(o, 16), this.dmq1 = P(s, 16), this.coeff = P(a, 16)) : console.error("Invalid RSA private key") }, t.prototype.generate = function(t, e) {
              var n = new J,
                r = t >> 1;
              this.e = parseInt(e, 16);
              for (var i = new k(e, 16);;) {
                for (; this.p = new k(t - r, 1, n), 0 != this.p.subtract(k.ONE).gcd(i).compareTo(k.ONE) || !this.p.isProbablePrime(10););
                for (; this.q = new k(r, 1, n), 0 != this.q.subtract(k.ONE).gcd(i).compareTo(k.ONE) || !this.q.isProbablePrime(10););
                if (this.p.compareTo(this.q) <= 0) {
                  var o = this.p;
                  this.p = this.q, this.q = o
                }
                var s = this.p.subtract(k.ONE),
                  a = this.q.subtract(k.ONE),
                  u = s.multiply(a);
                if (0 == u.gcd(i).compareTo(k.ONE)) { this.n = this.p.multiply(this.q), this.d = i.modInverse(u), this.dmp1 = this.d.mod(s), this.dmq1 = this.d.mod(a), this.coeff = this.q.modInverse(this.p); break }
              }
            }, t.prototype.decrypt = function(t) {
              var e = P(t, 16),
                n = this.doPrivate(e);
              return null == n ? null : function(t, e) {
                for (var n = t.toByteArray(), r = 0; r < n.length && 0 == n[r];) ++r;
                if (n.length - r != e - 1 || 2 != n[r]) return null;
                for (++r; 0 != n[r];)
                  if (++r >= n.length) return null;
                for (var i = ""; ++r < n.length;) {
                  var o = 255 & n[r];
                  o < 128 ? i += String.fromCharCode(o) : o > 191 && o < 224 ? (i += String.fromCharCode((31 & o) << 6 | 63 & n[r + 1]), ++r) : (i += String.fromCharCode((15 & o) << 12 | (63 & n[r + 1]) << 6 | 63 & n[r + 2]), r += 2)
                }
                return i
              }(n, this.n.bitLength() + 7 >> 3)
            }, t.prototype.generateAsync = function(t, e, n) {
              var r = new J,
                i = t >> 1;
              this.e = parseInt(e, 16);
              var o = new k(e, 16),
                s = this,
                a = function() {
                  var e = function() {
                      if (s.p.compareTo(s.q) <= 0) {
                        var t = s.p;
                        s.p = s.q, s.q = t
                      }
                      var e = s.p.subtract(k.ONE),
                        r = s.q.subtract(k.ONE),
                        i = e.multiply(r);
                      0 == i.gcd(o).compareTo(k.ONE) ? (s.n = s.p.multiply(s.q), s.d = o.modInverse(i), s.dmp1 = s.d.mod(e), s.dmq1 = s.d.mod(r), s.coeff = s.q.modInverse(s.p), setTimeout(function() { n() }, 0)) : setTimeout(a, 0)
                    },
                    u = function() { s.q = M(), s.q.fromNumberAsync(i, 1, r, function() { s.q.subtract(k.ONE).gcda(o, function(t) { 0 == t.compareTo(k.ONE) && s.q.isProbablePrime(10) ? setTimeout(e, 0) : setTimeout(u, 0) }) }) },
                    h = function() { s.p = M(), s.p.fromNumberAsync(t - i, 1, r, function() { s.p.subtract(k.ONE).gcda(o, function(t) { 0 == t.compareTo(k.ONE) && s.p.isProbablePrime(10) ? setTimeout(u, 0) : setTimeout(h, 0) }) }) };
                  setTimeout(h, 0)
                };
              setTimeout(a, 0)
            }, t.prototype.sign = function(t, e, n) { var r = function(t, e) { if (e < t.length + 22) return console.error("Message too long for RSA"), null; for (var n = e - t.length - 6, r = "", i = 0; i < n; i += 2) r += "ff"; return P("0001" + r + "00" + t, 16) }((Q[n] || "") + e(t).toString(), this.n.bitLength() / 4); if (null == r) return null; var i = this.doPrivate(r); if (null == i) return null; var o = i.toString(16); return 0 == (1 & o.length) ? o : "0" + o }, t.prototype.verify = function(t, e, n) {
              var r = P(e, 16),
                i = this.doPublic(r);
              return null == i ? null : function(t) {
                for (var e in Q)
                  if (Q.hasOwnProperty(e)) {
                    var n = Q[e],
                      r = n.length;
                    if (t.substr(0, r) == n) return t.substr(r)
                  }
                return t
              }(i.toString(16).replace(/^1f+00/, "")) == n(t).toString()
            }, t
          }(),
          Q = { md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", ripemd160: "3021300906052b2403020105000414" },
          tt = {};
        tt.lang = {
          extend: function(t, e, n) {
            if (!e || !t) throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");
            var r = function() {};
            if (r.prototype = e.prototype, t.prototype = new r, t.prototype.constructor = t, t.superclass = e.prototype, e.prototype.constructor == Object.prototype.constructor && (e.prototype.constructor = e), n) {
              var i;
              for (i in n) t.prototype[i] = n[i];
              var o = function() {},
                s = ["toString", "valueOf"];
              try {
                /MSIE/.test(navigator.userAgent) && (o = function(t, e) {
                  for (i = 0; i < s.length; i += 1) {
                    var n = s[i],
                      r = e[n];
                    "function" == typeof r && r != Object.prototype[n] && (t[n] = r)
                  }
                })
              } catch (t) {}
              o(t.prototype, n)
            }
          }
        };
        var et = {};
        void 0 !== et.asn1 && et.asn1 || (et.asn1 = {}), et.asn1.ASN1Util = new function() {
          this.integerToByteHex = function(t) { var e = t.toString(16); return e.length % 2 == 1 && (e = "0" + e), e }, this.bigIntToMinTwosComplementsHex = function(t) {
            var e = t.toString(16);
            if ("-" != e.substr(0, 1)) e.length % 2 == 1 ? e = "0" + e : e.match(/^[0-7]/) || (e = "00" + e);
            else {
              var n = e.substr(1).length;
              n % 2 == 1 ? n += 1 : e.match(/^[0-7]/) || (n += 2);
              for (var r = "", i = 0; i < n; i++) r += "f";
              e = new k(r, 16).xor(t).add(k.ONE).toString(16).replace(/^-/, "")
            }
            return e
          }, this.getPEMStringFromHex = function(t, e) { return hextopem(t, e) }, this.newObject = function(t) {
            var e = et.asn1,
              n = e.DERBoolean,
              r = e.DERInteger,
              i = e.DERBitString,
              o = e.DEROctetString,
              s = e.DERNull,
              a = e.DERObjectIdentifier,
              u = e.DEREnumerated,
              h = e.DERUTF8String,
              c = e.DERNumericString,
              l = e.DERPrintableString,
              f = e.DERTeletexString,
              d = e.DERIA5String,
              p = e.DERUTCTime,
              g = e.DERGeneralizedTime,
              m = e.DERSequence,
              v = e.DERSet,
              y = e.DERTaggedObject,
              b = e.ASN1Util.newObject,
              w = Object.keys(t);
            if (1 != w.length) throw "key of param shall be only one.";
            var S = w[0];
            if (-1 == ":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + S + ":")) throw "undefined key: " + S;
            if ("bool" == S) return new n(t[S]);
            if ("int" == S) return new r(t[S]);
            if ("bitstr" == S) return new i(t[S]);
            if ("octstr" == S) return new o(t[S]);
            if ("null" == S) return new s(t[S]);
            if ("oid" == S) return new a(t[S]);
            if ("enum" == S) return new u(t[S]);
            if ("utf8str" == S) return new h(t[S]);
            if ("numstr" == S) return new c(t[S]);
            if ("prnstr" == S) return new l(t[S]);
            if ("telstr" == S) return new f(t[S]);
            if ("ia5str" == S) return new d(t[S]);
            if ("utctime" == S) return new p(t[S]);
            if ("gentime" == S) return new g(t[S]);
            if ("seq" == S) {
              for (var T = t[S], E = [], D = 0; D < T.length; D++) {
                var A = b(T[D]);
                E.push(A)
              }
              return new m({ array: E })
            }
            if ("set" == S) { for (T = t[S], E = [], D = 0; D < T.length; D++) A = b(T[D]), E.push(A); return new v({ array: E }) }
            if ("tag" == S) { var x = t[S]; if ("[object Array]" === Object.prototype.toString.call(x) && 3 == x.length) { var I = b(x[2]); return new y({ tag: x[0], explicit: x[1], obj: I }) } var R = {}; if (void 0 !== x.explicit && (R.explicit = x.explicit), void 0 !== x.tag && (R.tag = x.tag), void 0 === x.obj) throw "obj shall be specified for 'tag'."; return R.obj = b(x.obj), new y(R) }
          }, this.jsonToASN1HEX = function(t) { return this.newObject(t).getEncodedHex() }
        }, et.asn1.ASN1Util.oidHexToInt = function(t) {
          for (var e = "", n = parseInt(t.substr(0, 2), 16), r = (e = Math.floor(n / 40) + "." + n % 40, ""), i = 2; i < t.length; i += 2) {
            var o = ("00000000" + parseInt(t.substr(i, 2), 16).toString(2)).slice(-8);
            r += o.substr(1, 7), "0" == o.substr(0, 1) && (e = e + "." + new k(r, 2).toString(10), r = "")
          }
          return e
        }, et.asn1.ASN1Util.oidIntToHex = function(t) {
          var e = function(t) { var e = t.toString(16); return 1 == e.length && (e = "0" + e), e },
            n = function(t) {
              var n = "",
                r = new k(t, 10).toString(2),
                i = 7 - r.length % 7;
              7 == i && (i = 0);
              for (var o = "", s = 0; s < i; s++) o += "0";
              for (r = o + r, s = 0; s < r.length - 1; s += 7) {
                var a = r.substr(s, 7);
                s != r.length - 7 && (a = "1" + a), n += e(parseInt(a, 2))
              }
              return n
            };
          if (!t.match(/^[0-9.]+$/)) throw "malformed oid string: " + t;
          var r = "",
            i = t.split("."),
            o = 40 * parseInt(i[0]) + parseInt(i[1]);
          r += e(o), i.splice(0, 2);
          for (var s = 0; s < i.length; s++) r += n(i[s]);
          return r
        }, et.asn1.ASN1Object = function() {
          this.getLengthHexFromValue = function() {
            if (void 0 === this.hV || null == this.hV) throw "this.hV is null or undefined.";
            if (this.hV.length % 2 == 1) throw "value hex must be even length: n=" + "".length + ",v=" + this.hV;
            var t = this.hV.length / 2,
              e = t.toString(16);
            if (e.length % 2 == 1 && (e = "0" + e), t < 128) return e;
            var n = e.length / 2;
            if (n > 15) throw "ASN.1 length too long to represent by 8x: n = " + t.toString(16);
            return (128 + n).toString(16) + e
          }, this.getEncodedHex = function() { return (null == this.hTLV || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV }, this.getValueHex = function() { return this.getEncodedHex(), this.hV }, this.getFreshValueHex = function() { return "" }
        }, et.asn1.DERAbstractString = function(t) { et.asn1.DERAbstractString.superclass.constructor.call(this), this.getString = function() { return this.s }, this.setString = function(t) { this.hTLV = null, this.isModified = !0, this.s = t, this.hV = stohex(this.s) }, this.setStringHex = function(t) { this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && ("string" == typeof t ? this.setString(t) : void 0 !== t.str ? this.setString(t.str) : void 0 !== t.hex && this.setStringHex(t.hex)) }, tt.lang.extend(et.asn1.DERAbstractString, et.asn1.ASN1Object), et.asn1.DERAbstractTime = function(t) {
          et.asn1.DERAbstractTime.superclass.constructor.call(this), this.localDateToUTC = function(t) { return utc = t.getTime() + 6e4 * t.getTimezoneOffset(), new Date(utc) }, this.formatDate = function(t, e, n) {
            var r = this.zeroPadding,
              i = this.localDateToUTC(t),
              o = String(i.getFullYear());
            "utc" == e && (o = o.substr(2, 2));
            var s = o + r(String(i.getMonth() + 1), 2) + r(String(i.getDate()), 2) + r(String(i.getHours()), 2) + r(String(i.getMinutes()), 2) + r(String(i.getSeconds()), 2);
            if (!0 === n) {
              var a = i.getMilliseconds();
              if (0 != a) {
                var u = r(String(a), 3);
                s = s + "." + (u = u.replace(/[0]+$/, ""))
              }
            }
            return s + "Z"
          }, this.zeroPadding = function(t, e) { return t.length >= e ? t : new Array(e - t.length + 1).join("0") + t }, this.getString = function() { return this.s }, this.setString = function(t) { this.hTLV = null, this.isModified = !0, this.s = t, this.hV = stohex(t) }, this.setByDateValue = function(t, e, n, r, i, o) {
            var s = new Date(Date.UTC(t, e - 1, n, r, i, o, 0));
            this.setByDate(s)
          }, this.getFreshValueHex = function() { return this.hV }
        }, tt.lang.extend(et.asn1.DERAbstractTime, et.asn1.ASN1Object), et.asn1.DERAbstractStructured = function(t) { et.asn1.DERAbstractString.superclass.constructor.call(this), this.setByASN1ObjectArray = function(t) { this.hTLV = null, this.isModified = !0, this.asn1Array = t }, this.appendASN1Object = function(t) { this.hTLV = null, this.isModified = !0, this.asn1Array.push(t) }, this.asn1Array = new Array, void 0 !== t && void 0 !== t.array && (this.asn1Array = t.array) }, tt.lang.extend(et.asn1.DERAbstractStructured, et.asn1.ASN1Object), et.asn1.DERBoolean = function() { et.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = "0101ff" }, tt.lang.extend(et.asn1.DERBoolean, et.asn1.ASN1Object), et.asn1.DERInteger = function(t) {
          et.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function(t) { this.hTLV = null, this.isModified = !0, this.hV = et.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t) }, this.setByInteger = function(t) {
            var e = new k(String(t), 10);
            this.setByBigInteger(e)
          }, this.setValueHex = function(t) { this.hV = t }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && (void 0 !== t.bigint ? this.setByBigInteger(t.bigint) : void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex))
        }, tt.lang.extend(et.asn1.DERInteger, et.asn1.ASN1Object), et.asn1.DERBitString = function(t) {
          if (void 0 !== t && void 0 !== t.obj) {
            var e = et.asn1.ASN1Util.newObject(t.obj);
            t.hex = "00" + e.getEncodedHex()
          }
          et.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(t) { this.hTLV = null, this.isModified = !0, this.hV = t }, this.setUnusedBitsAndHexValue = function(t, e) {
            if (t < 0 || 7 < t) throw "unused bits shall be from 0 to 7: u = " + t;
            var n = "0" + t;
            this.hTLV = null, this.isModified = !0, this.hV = n + e
          }, this.setByBinaryString = function(t) {
            var e = 8 - (t = t.replace(/0+$/, "")).length % 8;
            8 == e && (e = 0);
            for (var n = 0; n <= e; n++) t += "0";
            var r = "";
            for (n = 0; n < t.length - 1; n += 8) {
              var i = t.substr(n, 8),
                o = parseInt(i, 2).toString(16);
              1 == o.length && (o = "0" + o), r += o
            }
            this.hTLV = null, this.isModified = !0, this.hV = "0" + e + r
          }, this.setByBooleanArray = function(t) {
            for (var e = "", n = 0; n < t.length; n++) 1 == t[n] ? e += "1" : e += "0";
            this.setByBinaryString(e)
          }, this.newFalseArray = function(t) { for (var e = new Array(t), n = 0; n < t; n++) e[n] = !1; return e }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && ("string" == typeof t && t.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(t) : void 0 !== t.hex ? this.setHexValueIncludingUnusedBits(t.hex) : void 0 !== t.bin ? this.setByBinaryString(t.bin) : void 0 !== t.array && this.setByBooleanArray(t.array))
        }, tt.lang.extend(et.asn1.DERBitString, et.asn1.ASN1Object), et.asn1.DEROctetString = function(t) {
          if (void 0 !== t && void 0 !== t.obj) {
            var e = et.asn1.ASN1Util.newObject(t.obj);
            t.hex = e.getEncodedHex()
          }
          et.asn1.DEROctetString.superclass.constructor.call(this, t), this.hT = "04"
        }, tt.lang.extend(et.asn1.DEROctetString, et.asn1.DERAbstractString), et.asn1.DERNull = function() { et.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500" }, tt.lang.extend(et.asn1.DERNull, et.asn1.ASN1Object), et.asn1.DERObjectIdentifier = function(t) {
          var e = function(t) { var e = t.toString(16); return 1 == e.length && (e = "0" + e), e },
            n = function(t) {
              var n = "",
                r = new k(t, 10).toString(2),
                i = 7 - r.length % 7;
              7 == i && (i = 0);
              for (var o = "", s = 0; s < i; s++) o += "0";
              for (r = o + r, s = 0; s < r.length - 1; s += 7) {
                var a = r.substr(s, 7);
                s != r.length - 7 && (a = "1" + a), n += e(parseInt(a, 2))
              }
              return n
            };
          et.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(t) { this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t }, this.setValueOidString = function(t) {
            if (!t.match(/^[0-9.]+$/)) throw "malformed oid string: " + t;
            var r = "",
              i = t.split("."),
              o = 40 * parseInt(i[0]) + parseInt(i[1]);
            r += e(o), i.splice(0, 2);
            for (var s = 0; s < i.length; s++) r += n(i[s]);
            this.hTLV = null, this.isModified = !0, this.s = null, this.hV = r
          }, this.setValueName = function(t) {
            var e = et.asn1.x509.OID.name2oid(t);
            if ("" === e) throw "DERObjectIdentifier oidName undefined: " + t;
            this.setValueOidString(e)
          }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && ("string" == typeof t ? t.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t) : this.setValueName(t) : void 0 !== t.oid ? this.setValueOidString(t.oid) : void 0 !== t.hex ? this.setValueHex(t.hex) : void 0 !== t.name && this.setValueName(t.name))
        }, tt.lang.extend(et.asn1.DERObjectIdentifier, et.asn1.ASN1Object), et.asn1.DEREnumerated = function(t) {
          et.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(t) { this.hTLV = null, this.isModified = !0, this.hV = et.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t) }, this.setByInteger = function(t) {
            var e = new k(String(t), 10);
            this.setByBigInteger(e)
          }, this.setValueHex = function(t) { this.hV = t }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && (void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex))
        }, tt.lang.extend(et.asn1.DEREnumerated, et.asn1.ASN1Object), et.asn1.DERUTF8String = function(t) { et.asn1.DERUTF8String.superclass.constructor.call(this, t), this.hT = "0c" }, tt.lang.extend(et.asn1.DERUTF8String, et.asn1.DERAbstractString), et.asn1.DERNumericString = function(t) { et.asn1.DERNumericString.superclass.constructor.call(this, t), this.hT = "12" }, tt.lang.extend(et.asn1.DERNumericString, et.asn1.DERAbstractString), et.asn1.DERPrintableString = function(t) { et.asn1.DERPrintableString.superclass.constructor.call(this, t), this.hT = "13" }, tt.lang.extend(et.asn1.DERPrintableString, et.asn1.DERAbstractString), et.asn1.DERTeletexString = function(t) { et.asn1.DERTeletexString.superclass.constructor.call(this, t), this.hT = "14" }, tt.lang.extend(et.asn1.DERTeletexString, et.asn1.DERAbstractString), et.asn1.DERIA5String = function(t) { et.asn1.DERIA5String.superclass.constructor.call(this, t), this.hT = "16" }, tt.lang.extend(et.asn1.DERIA5String, et.asn1.DERAbstractString), et.asn1.DERUTCTime = function(t) { et.asn1.DERUTCTime.superclass.constructor.call(this, t), this.hT = "17", this.setByDate = function(t) { this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "utc"), this.hV = stohex(this.s) }, this.getFreshValueHex = function() { return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "utc"), this.hV = stohex(this.s)), this.hV }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{12}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date)) }, tt.lang.extend(et.asn1.DERUTCTime, et.asn1.DERAbstractTime), et.asn1.DERGeneralizedTime = function(t) { et.asn1.DERGeneralizedTime.superclass.constructor.call(this, t), this.hT = "18", this.withMillis = !1, this.setByDate = function(t) { this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = stohex(this.s) }, this.getFreshValueHex = function() { return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = stohex(this.s)), this.hV }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{14}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date), !0 === t.millis && (this.withMillis = !0)) }, tt.lang.extend(et.asn1.DERGeneralizedTime, et.asn1.DERAbstractTime), et.asn1.DERSequence = function(t) { et.asn1.DERSequence.superclass.constructor.call(this, t), this.hT = "30", this.getFreshValueHex = function() { for (var t = "", e = 0; e < this.asn1Array.length; e++) t += this.asn1Array[e].getEncodedHex(); return this.hV = t, this.hV } }, tt.lang.extend(et.asn1.DERSequence, et.asn1.DERAbstractStructured), et.asn1.DERSet = function(t) {
          et.asn1.DERSet.superclass.constructor.call(this, t), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function() {
            for (var t = new Array, e = 0; e < this.asn1Array.length; e++) {
              var n = this.asn1Array[e];
              t.push(n.getEncodedHex())
            }
            return 1 == this.sortFlag && t.sort(), this.hV = t.join(""), this.hV
          }, void 0 !== t && void 0 !== t.sortflag && 0 == t.sortflag && (this.sortFlag = !1)
        }, tt.lang.extend(et.asn1.DERSet, et.asn1.DERAbstractStructured), et.asn1.DERTaggedObject = function(t) { et.asn1.DERTaggedObject.superclass.constructor.call(this), this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.setASN1Object = function(t, e, n) { this.hT = e, this.isExplicit = t, this.asn1Object = n, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = !0) : (this.hV = null, this.hTLV = n.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, e), this.isModified = !1) }, this.getFreshValueHex = function() { return this.hV }, void 0 !== t && (void 0 !== t.tag && (this.hT = t.tag), void 0 !== t.explicit && (this.isExplicit = t.explicit), void 0 !== t.obj && (this.asn1Object = t.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object))) }, tt.lang.extend(et.asn1.DERTaggedObject, et.asn1.ASN1Object);
        var nt = function(t) {
            function e(n) { var r = t.call(this) || this; return n && ("string" == typeof n ? r.parseKey(n) : (e.hasPrivateKeyProperty(n) || e.hasPublicKeyProperty(n)) && r.parsePropertiesFrom(n)), r }
            return function(t, e) {
              function n() { this.constructor = t }
              g(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n)
            }(e, t), e.prototype.parseKey = function(t) {
              try {
                var e = 0,
                  n = 0,
                  r = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/.test(t) ? m(t) : v.unarmor(t),
                  i = A.decode(r);
                if (3 === i.sub.length && (i = i.sub[2].sub[0]), 9 === i.sub.length) {
                  e = i.sub[1].getHexStringValue(), this.n = P(e, 16), n = i.sub[2].getHexStringValue(), this.e = parseInt(n, 16);
                  var o = i.sub[3].getHexStringValue();
                  this.d = P(o, 16);
                  var s = i.sub[4].getHexStringValue();
                  this.p = P(s, 16);
                  var a = i.sub[5].getHexStringValue();
                  this.q = P(a, 16);
                  var u = i.sub[6].getHexStringValue();
                  this.dmp1 = P(u, 16);
                  var h = i.sub[7].getHexStringValue();
                  this.dmq1 = P(h, 16);
                  var c = i.sub[8].getHexStringValue();
                  this.coeff = P(c, 16)
                } else {
                  if (2 !== i.sub.length) return !1;
                  var l = i.sub[1].sub[0];
                  e = l.sub[0].getHexStringValue(), this.n = P(e, 16), n = l.sub[1].getHexStringValue(), this.e = parseInt(n, 16)
                }
                return !0
              } catch (t) { return !1 }
            }, e.prototype.getPrivateBaseKey = function() { var t = { array: [new et.asn1.DERInteger({ int: 0 }), new et.asn1.DERInteger({ bigint: this.n }), new et.asn1.DERInteger({ int: this.e }), new et.asn1.DERInteger({ bigint: this.d }), new et.asn1.DERInteger({ bigint: this.p }), new et.asn1.DERInteger({ bigint: this.q }), new et.asn1.DERInteger({ bigint: this.dmp1 }), new et.asn1.DERInteger({ bigint: this.dmq1 }), new et.asn1.DERInteger({ bigint: this.coeff })] }; return new et.asn1.DERSequence(t).getEncodedHex() }, e.prototype.getPrivateBaseKeyB64 = function() { return l(this.getPrivateBaseKey()) }, e.prototype.getPublicBaseKey = function() {
              var t = new et.asn1.DERSequence({ array: [new et.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }), new et.asn1.DERNull] }),
                e = new et.asn1.DERSequence({ array: [new et.asn1.DERInteger({ bigint: this.n }), new et.asn1.DERInteger({ int: this.e })] }),
                n = new et.asn1.DERBitString({ hex: "00" + e.getEncodedHex() });
              return new et.asn1.DERSequence({ array: [t, n] }).getEncodedHex()
            }, e.prototype.getPublicBaseKeyB64 = function() { return l(this.getPublicBaseKey()) }, e.wordwrap = function(t, e) { if (!t) return t; var n = "(.{1," + (e = e || 64) + "})( +|$\n?)|(.{1," + e + "})"; return t.match(RegExp(n, "g")).join("\n") }, e.prototype.getPrivateKey = function() { var t = "-----BEGIN RSA PRIVATE KEY-----\n"; return t += e.wordwrap(this.getPrivateBaseKeyB64()) + "\n", t += "-----END RSA PRIVATE KEY-----" }, e.prototype.getPublicKey = function() { var t = "-----BEGIN PUBLIC KEY-----\n"; return t += e.wordwrap(this.getPublicBaseKeyB64()) + "\n", t += "-----END PUBLIC KEY-----" }, e.hasPublicKeyProperty = function(t) { return (t = t || {}).hasOwnProperty("n") && t.hasOwnProperty("e") }, e.hasPrivateKeyProperty = function(t) { return (t = t || {}).hasOwnProperty("n") && t.hasOwnProperty("e") && t.hasOwnProperty("d") && t.hasOwnProperty("p") && t.hasOwnProperty("q") && t.hasOwnProperty("dmp1") && t.hasOwnProperty("dmq1") && t.hasOwnProperty("coeff") }, e.prototype.parsePropertiesFrom = function(t) { this.n = t.n, this.e = t.e, t.hasOwnProperty("d") && (this.d = t.d, this.p = t.p, this.q = t.q, this.dmp1 = t.dmp1, this.dmq1 = t.dmq1, this.coeff = t.coeff) }, e
          }(W),
          rt = function() {
            function t(t) { t = t || {}, this.default_key_size = parseInt(t.default_key_size, 10) || 1024, this.default_public_exponent = t.default_public_exponent || "010001", this.log = t.log || !1, this.key = null }
            return t.prototype.setKey = function(t) { this.log && this.key && console.warn("A key was already set, overriding existing."), this.key = new nt(t) }, t.prototype.setPrivateKey = function(t) { this.setKey(t) }, t.prototype.setPublicKey = function(t) { this.setKey(t) }, t.prototype.decrypt = function(t) { try { return this.getKey().decrypt(f(t)) } catch (t) { return !1 } }, t.prototype.encrypt = function(t) { try { return l(this.getKey().encrypt(t)) } catch (t) { return !1 } }, t.prototype.sign = function(t, e, n) { try { return l(this.getKey().sign(t, e, n)) } catch (t) { return !1 } }, t.prototype.verify = function(t, e, n) { try { return this.getKey().verify(t, f(e), n) } catch (t) { return !1 } }, t.prototype.getKey = function(t) {
              if (!this.key) {
                if (this.key = new nt, t && "[object Function]" === {}.toString.call(t)) return void this.key.generateAsync(this.default_key_size, this.default_public_exponent, t);
                this.key.generate(this.default_key_size, this.default_public_exponent)
              }
              return this.key
            }, t.prototype.getPrivateKey = function() { return this.getKey().getPrivateKey() }, t.prototype.getPrivateKeyB64 = function() { return this.getKey().getPrivateBaseKeyB64() }, t.prototype.getPublicKey = function() { return this.getKey().getPublicKey() }, t.prototype.getPublicKeyB64 = function() { return this.getKey().getPublicBaseKeyB64() }, t.version = "3.0.0-rc.1", t
          }();
        window.JSEncrypt = rt, t.JSEncrypt = rt, t.default = rt, Object.defineProperty(t, "__esModule", { value: !0 })
      }(e)
    }(e = { exports: {} }, e.exports), e.exports),
    i = (n = r) && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
  var o = { INVALID_NUMBER: { code: "INVALID_NUMBER", message: "invalid card `number`" }, INVALID_NUMBER_LENGTH: { code: "INVALID_NUMBER", message: "invalid field `number`. You must pass a value between 13 and 19 digits" }, INVALID_SECURITY_CODE: { code: "INVALID_SECURITY_CODE", message: "invalid field `securityCode`. You must pass a value with 3, 4 or none digits" }, INVALID_EXPIRATION_MONTH: { code: "INVALID_EXPIRATION_MONTH", message: "invalid field `expMonth`. You must pass a value between 1 and 12" }, INVALID_EXPIRATION_YEAR: { code: "INVALID_EXPIRATION_YEAR", message: "invalid field `expYear`. You must pass a value between 1900 and 2099" }, INVALID_PUBLIC_KEY: { code: "INVALID_PUBLIC_KEY", message: "invalid `publicKey`" }, INVALID_HOLDER: { code: "INVALID_HOLDER", message: "invalid `holder`" } };

  function s(t, e) { return ((t || "") + "").trim() }

  function a(t) { const e = s(t); return 1 === e.length ? `0${e}` : e }

  function u({ number: t }) { if (!t) return o.INVALID_NUMBER }

  function h({ number: t }) { if (t && !l(t)) return o.INVALID_NUMBER }

  function c({ number: t }) { if (t && !(t.length >= 13 && t.length <= 19)) return o.INVALID_NUMBER_LENGTH }

  function l(t) { return !isNaN(t) }

  function f({ securityCode: t }) { if (t && (!l(t) || 3 !== t.length && 4 !== t.length)) return o.INVALID_SECURITY_CODE }

  function d({ expMonth: t }) { if (!t || !(l(t) && parseInt(t, 10) >= 1 && parseInt(t, 10) <= 12)) return o.INVALID_EXPIRATION_MONTH }

  function p({ expYear: t }) { if (!t || !(l(t) && parseInt(t, 10) >= 1900 && parseInt(t, 10) <= 2099)) return o.INVALID_EXPIRATION_YEAR }

  function g({ holder: t }) { if (!t || /\d/.test(t)) return o.INVALID_HOLDER }

  function m(t) { return [u, h, c, f, d, p, g].map(e => e(t)).filter(t => t) }
  const v = new i;
  var y = t => {
    const e = function(t) { return { holder: (e = t.holder, n = 30, s(e).substring(0, n)), number: s(t.number), securityCode: s(t.securityCode), expMonth: a(t.expMonth), expYear: s(t.expYear), publicKey: s(t.publicKey) }; var e, n }(t),
      n = { errors: m(e), encryptedCard: null, hasErrors: !0 };
    if (0 === n.errors.length) {
      v.setPublicKey(e.publicKey);
      const { number: t, holder: r, securityCode: i, expMonth: s, expYear: a } = e, u = v.encrypt(`${t};${i};${s};${a};${r};${Date.now()}`);
      u ? (n.hasErrors = !1, n.encryptedCard = u) : n.errors.push(o.INVALID_PUBLIC_KEY)
    }
    return n
  };
  const b = new class {
    constructor() { this.environment = "PROD", this.session = "FORBIDDEN" }
    getEnvironment() { return this.environment }
    getSession() { return this.session }
    setUp(t) { this.environment = t.env || this.environment, this.session = t.session || this.session }
    urls() {
      switch (this.environment) {
        case "LOCAL":
          return { checkoutSdkService: "http://localhost:8085", songbird: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js" };
        case "QA":
          return { checkoutSdkService: "https://qa.sdk.pagseguro.com/checkout-sdk", songbird: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js" };
        case "SANDBOX-QA":
          return { checkoutSdkService: "https://sandbox.qa.sdk.pagseguro.com/checkout-sdk", songbird: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js" };
        case "SANDBOX":
          return { checkoutSdkService: "https://sandbox.sdk.pagseguro.com/checkout-sdk", songbird: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js" };
        default:
          return { checkoutSdkService: "https://sdk.pagseguro.com/checkout-sdk", songbird: "https://songbird.cardinalcommerce.com/edge/v1/songbird.js" }
      }
    }
  };
  class w extends Error { constructor(t, e) { super(t), this.name = "PagSeguroError", this.detail = e } }
  async function S(t) { const e = await fetch(t.url, { method: t.method, body: t.body ? JSON.stringify(t.body) : null, headers: { Authorization: b.getSession(), "Content-Type": "application/json" } }); let n = await e.json(); if (!e.ok) throw new w(t.method + " from " + t.url + " return " + e.status, n); return n }
  let T = !1;
  const E = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.Et9HFtf9R3GEMA0IICOfFMVXY7kkTX1wr4qCyhIf58U";
  var D = function() {
    return (D = Object.assign || function(t) {
      for (var e, n = 1, r = arguments.length; n < r; n++)
        for (var i in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      return t
    }).apply(this, arguments)
  };

  function A(t, e, n, r) {
    return new(n || (n = Promise))(function(i, o) {
      function s(t) { try { u(r.next(t)) } catch (t) { o(t) } }

      function a(t) { try { u(r.throw(t)) } catch (t) { o(t) } }

      function u(t) {
        var e;
        t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) { t(e) })).then(s, a)
      }
      u((r = r.apply(t, e || [])).next())
    })
  }

  function x(t, e) {
    var n, r, i, o, s = { label: 0, sent: function() { if (1 & i[0]) throw i[1]; return i[1] }, trys: [], ops: [] };
    return o = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function() { return this }), o;

    function a(o) {
      return function(a) {
        return function(o) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; s;) try {
            if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
            switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;
              case 4:
                return s.label++, { value: o[1], done: !1 };
              case 5:
                s.label++, r = o[1], o = [0];
                continue;
              case 7:
                o = s.ops.pop(), s.trys.pop();
                continue;
              default:
                if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) { s = 0; continue }
                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) { s.label = o[1]; break }
                if (6 === o[0] && s.label < i[1]) { s.label = i[1], i = o; break }
                if (i && s.label < i[2]) { s.label = i[2], s.ops.push(o); break }
                i[2] && s.ops.pop(), s.trys.pop();
                continue
            }
            o = e.call(t, s)
          } catch (t) { o = [6, t], r = 0 } finally { n = i = 0 }
          if (5 & o[0]) throw o[1];
          return { value: o[0] ? o[1] : void 0, done: !0 }
        }([o, a])
      }
    }
  }

  function I() {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
    var r = Array(t),
      i = 0;
    for (e = 0; e < n; e++)
      for (var o = arguments[e], s = 0, a = o.length; s < a; s++, i++) r[i] = o[s];
    return r
  }
  var R = "3.3.2";

  function k(t, e) { return new Promise(function(n) { return setTimeout(n, t, e) }) }

  function B(t, e) {
    try {
      var n = t();
      (r = n) && "function" == typeof r.then ? n.then(function(t) { return e(!0, t) }, function(t) { return e(!1, t) }) : e(!0, n)
    } catch (t) { e(!1, t) }
    var r
  }

  function O(t, e, n) {
    return void 0 === n && (n = 16), A(this, void 0, void 0, function() {
      var r, i, o;
      return x(this, function(s) {
        switch (s.label) {
          case 0:
            r = Date.now(), i = 0, s.label = 1;
          case 1:
            return i < t.length ? (e(t[i], i), (o = Date.now()) >= r + n ? (r = o, [4, k(0)]) : [3, 3]) : [3, 4];
          case 2:
            s.sent(), s.label = 3;
          case 3:
            return ++i, [3, 1];
          case 4:
            return [2]
        }
      })
    })
  }

  function C(t, e) { t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]], e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]; var n = [0, 0, 0, 0]; return n[3] += t[3] + e[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += t[2] + e[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += t[1] + e[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += t[0] + e[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]] }

  function N(t, e) { t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]], e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]; var n = [0, 0, 0, 0]; return n[3] += t[3] * e[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += t[2] * e[3], n[1] += n[2] >>> 16, n[2] &= 65535, n[2] += t[3] * e[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += t[1] * e[3], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += t[2] * e[2], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += t[3] * e[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += t[0] * e[3] + t[1] * e[2] + t[2] * e[1] + t[3] * e[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]] }

  function M(t, e) { return 32 === (e %= 64) ? [t[1], t[0]] : e < 32 ? [t[0] << e | t[1] >>> 32 - e, t[1] << e | t[0] >>> 32 - e] : (e -= 32, [t[1] << e | t[0] >>> 32 - e, t[0] << e | t[1] >>> 32 - e]) }

  function P(t, e) { return 0 === (e %= 64) ? t : e < 32 ? [t[0] << e | t[1] >>> 32 - e, t[1] << e] : [t[1] << e - 32, 0] }

  function V(t, e) { return [t[0] ^ e[0], t[1] ^ e[1]] }

  function L(t) { return t = V(t, [0, t[0] >>> 1]), t = V(t = N(t, [4283543511, 3981806797]), [0, t[0] >>> 1]), t = V(t = N(t, [3301882366, 444984403]), [0, t[0] >>> 1]) }

  function _(t) { return parseInt(t) }

  function j(t) { return parseFloat(t) }

  function H(t, e) { return "number" == typeof t && isNaN(t) ? e : t }

  function q(t) { return t.reduce(function(t, e) { return t + (e ? 1 : 0) }, 0) }

  function F(t, e) { if (void 0 === e && (e = 1), Math.abs(e) >= 1) return Math.round(t / e) * e; var n = 1 / e; return Math.round(t * n) / n }

  function U(t) { return t && "object" == typeof t && "message" in t ? t : { message: t } }

  function z(t, e, n) {
    var r = Object.keys(t).filter(function(t) {
        return ! function(t, e) {
          for (var n = 0, r = t.length; n < r; ++n)
            if (t[n] === e) return !0;
          return !1
        }(n, t)
      }),
      i = Array(r.length);
    return O(r, function(n, r) {
        i[r] = function(t, e) {
          var n = function(t) { return "function" != typeof t },
            r = new Promise(function(r) {
              var i = Date.now();
              B(t.bind(null, e), function() {
                for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
                var o = Date.now() - i;
                if (!t[0]) return r(function() { return { error: U(t[1]), duration: o } });
                var s = t[1];
                if (n(s)) return r(function() { return { value: s, duration: o } });
                r(function() {
                  return new Promise(function(t) {
                    var e = Date.now();
                    B(s, function() {
                      for (var n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
                      var i = o + Date.now() - e;
                      if (!n[0]) return t({ error: U(n[1]), duration: i });
                      t({ value: n[1], duration: i })
                    })
                  })
                })
              })
            });
          return function() { return r.then(function(t) { return t() }) }
        }(t[n], e)
      }),
      function() {
        return A(this, void 0, void 0, function() {
          var t, e, n, o, s, a;
          return x(this, function(u) {
            switch (u.label) {
              case 0:
                for (t = {}, e = 0, n = r; e < n.length; e++) o = n[e], t[o] = void 0;
                s = Array(r.length), a = function() {
                  var e;
                  return x(this, function(n) {
                    switch (n.label) {
                      case 0:
                        return e = !0, [4, O(r, function(n, r) { s[r] || (i[r] ? s[r] = i[r]().then(function(e) { return t[n] = e }) : e = !1) })];
                      case 1:
                        return n.sent(), e ? [2, "break"] : [4, k(1)];
                      case 2:
                        return n.sent(), [2]
                    }
                  })
                }, u.label = 1;
              case 1:
                return [5, a()];
              case 2:
                if ("break" === u.sent()) return [3, 4];
                u.label = 3;
              case 3:
                return [3, 1];
              case 4:
                return [4, Promise.all(s)];
              case 5:
                return u.sent(), [2, t]
            }
          })
        })
      }
  }

  function K() {
    var t = window,
      e = navigator;
    return q(["MSCSSMatrix" in t, "msSetImmediate" in t, "msIndexedDB" in t, "msMaxTouchPoints" in e, "msPointerEnabled" in e]) >= 4
  }

  function G() {
    var t = window,
      e = navigator;
    return q(["webkitPersistentStorage" in e, "webkitTemporaryStorage" in e, 0 === e.vendor.indexOf("Google"), "webkitResolveLocalFileSystemURL" in t, "BatteryManager" in t, "webkitMediaStream" in t, "webkitSpeechGrammar" in t]) >= 5
  }

  function Y() {
    var t = window,
      e = navigator;
    return q(["ApplePayError" in t, "CSSPrimitiveValue" in t, "Counter" in t, 0 === e.vendor.indexOf("Apple"), "getStorageUpdates" in e, "WebKitMediaKeys" in t]) >= 4
  }

  function X() { var t = window; return q(["safari" in t, !("DeviceMotionEvent" in t), !("ongestureend" in t), !("standalone" in navigator)]) >= 3 }

  function $() { var t = document; return (t.exitFullscreen || t.msExitFullscreen || t.mozCancelFullScreen || t.webkitExitFullscreen).call(t) }

  function Z() {
    var t = G(),
      e = function() { var t, e, n = window; return q(["buildID" in navigator, "MozAppearance" in (null !== (e = null === (t = document.documentElement) || void 0 === t ? void 0 : t.style) && void 0 !== e ? e : {}), "onmozfullscreenchange" in n, "mozInnerScreenX" in n, "CSSMozDocumentRule" in n, "CanvasCaptureMediaStream" in n]) >= 4 }();
    if (!t && !e) return !1;
    var n = window;
    return q(["onorientationchange" in n, "orientation" in n, t && !("SharedWorker" in n), e && /android/i.test(navigator.appVersion)]) >= 2
  }

  function J(t) { var e = new Error(t); return e.name = t, e }

  function W(t, e, n) {
    var r, i, o;
    return void 0 === n && (n = 50), A(this, void 0, void 0, function() {
      var s, a;
      return x(this, function(u) {
        switch (u.label) {
          case 0:
            s = document, u.label = 1;
          case 1:
            return s.body ? [3, 3] : [4, k(n)];
          case 2:
            return u.sent(), [3, 1];
          case 3:
            a = s.createElement("iframe"), u.label = 4;
          case 4:
            return u.trys.push([4, , 10, 11]), [4, new Promise(function(t, n) {
              var r = !1,
                i = function() { r = !0, t() };
              a.onload = i, a.onerror = function(t) { r = !0, n(t) };
              var o = a.style;
              o.setProperty("display", "block", "important"), o.position = "absolute", o.top = "0", o.left = "0", o.visibility = "hidden", e && "srcdoc" in a ? a.srcdoc = e : a.src = "about:blank", s.body.appendChild(a);
              var u = function() {
                var t, e;
                r || ("complete" === (null === (e = null === (t = a.contentWindow) || void 0 === t ? void 0 : t.document) || void 0 === e ? void 0 : e.readyState) ? i() : setTimeout(u, 10))
              };
              u()
            })];
          case 5:
            u.sent(), u.label = 6;
          case 6:
            return (null === (i = null === (r = a.contentWindow) || void 0 === r ? void 0 : r.document) || void 0 === i ? void 0 : i.body) ? [3, 8] : [4, k(n)];
          case 7:
            return u.sent(), [3, 6];
          case 8:
            return [4, t(a, a.contentWindow)];
          case 9:
            return [2, u.sent()];
          case 10:
            return null === (o = a.parentNode) || void 0 === o || o.removeChild(a), [7];
          case 11:
            return [2]
        }
      })
    })
  }

  function Q(t) {
    for (var e = function(t) {
        for (var e, n, r = "Unexpected syntax '" + t + "'", i = /^\s*([a-z-]*)(.*)$/i.exec(t), o = i[1] || void 0, s = {}, a = /([.:#][\w-]+|\[.+?\])/gi, u = function(t, e) { s[t] = s[t] || [], s[t].push(e) };;) {
          var h = a.exec(i[2]);
          if (!h) break;
          var c = h[0];
          switch (c[0]) {
            case ".":
              u("class", c.slice(1));
              break;
            case "#":
              u("id", c.slice(1));
              break;
            case "[":
              var l = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(c);
              if (!l) throw new Error(r);
              u(l[1], null !== (n = null !== (e = l[4]) && void 0 !== e ? e : l[5]) && void 0 !== n ? n : "");
              break;
            default:
              throw new Error(r)
          }
        }
        return [o, s]
      }(t), n = e[0], r = e[1], i = document.createElement(null != n ? n : "div"), o = 0, s = Object.keys(r); o < s.length; o++) {
      var a = s[o];
      i.setAttribute(a, r[a].join(" "))
    }
    return i
  }
  var tt = "mmMwWLliI0O&1",
    et = "48px",
    nt = ["monospace", "sans-serif", "serif"],
    rt = ["sans-serif-thin", "ARNO PRO", "Agency FB", "Arabic Typesetting", "Arial Unicode MS", "AvantGarde Bk BT", "BankGothic Md BT", "Batang", "Bitstream Vera Sans Mono", "Calibri", "Century", "Century Gothic", "Clarendon", "EUROSTILE", "Franklin Gothic", "Futura Bk BT", "Futura Md BT", "GOTHAM", "Gill Sans", "HELV", "Haettenschweiler", "Helvetica Neue", "Humanst521 BT", "Leelawadee", "Letter Gothic", "Levenim MT", "Lucida Bright", "Lucida Sans", "Menlo", "MS Mincho", "MS Outlook", "MS Reference Specialty", "MS UI Gothic", "MT Extra", "MYRIAD PRO", "Marlett", "Meiryo UI", "Microsoft Uighur", "Minion Pro", "Monotype Corsiva", "PMingLiU", "Pristina", "SCRIPTINA", "Segoe UI Light", "Serifa", "SimHei", "Small Fonts", "Staccato222 BT", "TRAJAN PRO", "Univers CE 55 Medium", "Vrinda", "ZWAdobeF"];

  function it(t) { return t.rect(0, 0, 10, 10), t.rect(2, 2, 6, 6), !t.isPointInPath(5, 5, "evenodd") }

  function ot(t, e) { t.width = 240, t.height = 60, e.textBaseline = "alphabetic", e.fillStyle = "#f60", e.fillRect(100, 1, 62, 20), e.fillStyle = "#069", e.font = '11pt "Times New Roman"'; var n = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835); return e.fillText(n, 2, 15), e.fillStyle = "rgba(102, 204, 0, 0.2)", e.font = "18pt Arial", e.fillText(n, 4, 45), at(t) }

  function st(t, e) {
    t.width = 122, t.height = 110, e.globalCompositeOperation = "multiply";
    for (var n = 0, r = [
        ["#f2f", 40, 40],
        ["#2ff", 80, 40],
        ["#ff2", 60, 80]
      ]; n < r.length; n++) {
      var i = r[n],
        o = i[0],
        s = i[1],
        a = i[2];
      e.fillStyle = o, e.beginPath(), e.arc(s, a, 40, 0, 2 * Math.PI, !0), e.closePath(), e.fill()
    }
    return e.fillStyle = "#f9c", e.arc(60, 60, 60, 0, 2 * Math.PI, !0), e.arc(60, 60, 20, 0, 2 * Math.PI, !0), e.fill("evenodd"), at(t)
  }

  function at(t) { return t.toDataURL() }
  var ut, ht, ct = 2500,
    lt = 10;

  function ft() {
    var t = this;
    return function() {
        if (void 0 === ht) {
          var t = function() {
            var e = dt();
            pt(e) ? ht = setTimeout(t, ct) : (ut = e, ht = void 0)
          };
          t()
        }
      }(),
      function() {
        return A(t, void 0, void 0, function() {
          var t;
          return x(this, function(e) {
            switch (e.label) {
              case 0:
                return pt(t = dt()) ? ut ? [2, I(ut)] : (n = document).fullscreenElement || n.msFullscreenElement || n.mozFullScreenElement || n.webkitFullscreenElement ? [4, $()] : [3, 2] : [3, 2];
              case 1:
                e.sent(), t = dt(), e.label = 2;
              case 2:
                return pt(t) || (ut = t), [2, t]
            }
            var n
          })
        })
      }
  }

  function dt() { var t = screen; return [H(j(t.availTop), null), H(j(t.width) - j(t.availWidth) - H(j(t.availLeft), 0), null), H(j(t.height) - j(t.availHeight) - H(j(t.availTop), 0), null), H(j(t.availLeft), null)] }

  function pt(t) {
    for (var e = 0; e < 4; ++e)
      if (t[e]) return !1;
    return !0
  }
  var gt = { abpIndo: ["#Iklan-Melayang", "#Kolom-Iklan-728", "#SidebarIklan-wrapper", 'a[title="7naga poker" i]', '[title="ALIENBOLA" i]'], abpvn: ["#quangcaomb", ".iosAdsiosAds-layout", ".quangcao", '[href^="https://r88.vn/"]', '[href^="https://zbet.vn/"]'], adBlockFinland: [".mainostila", ".sponsorit", ".ylamainos", 'a[href*="/clickthrgh.asp?"]', 'a[href^="https://app.readpeak.com/ads"]'], adBlockPersian: ["#navbar_notice_50", 'a[href^="http://g1.v.fwmrm.net/ad/"]', ".kadr", 'TABLE[width="140px"]', "#divAgahi"], adBlockWarningRemoval: ["#adblock-honeypot", ".adblocker-root", ".wp_adblock_detect"], adGuardAnnoyances: ['amp-embed[type="zen"]', ".hs-sosyal", "#cookieconsentdiv", 'div[class^="app_gdpr"]', ".as-oil"], adGuardBase: ["#ad-after", "#ad-p3", ".BetterJsPopOverlay", "#ad_300X250", "#bannerfloat22"], adGuardChinese: ['#piao_div_0[style*="width:140px;"]', 'a[href*=".ttz5.cn"]', 'a[href*=".yabovip2027.com/"]', ".tm3all2h4b", ".cc5278_banner_ad"], adGuardFrench: [".zonepub", '[class*="_adLeaderboard"]', '[id^="block-xiti_oas-"]', 'a[href^="http://ptapjmp.com/"]', 'a[href^="https://go.alvexo.com/"]'], adGuardGerman: [".banneritemwerbung_head_1", ".boxstartwerbung", ".werbung3", 'a[href^="http://www.eis.de/index.phtml?refid="]', 'a[href^="https://www.tipico.com/?affiliateId="]'], adGuardJapanese: ["#kauli_yad_1", "#ad-giftext", "#adsSPRBlock", 'a[href^="http://ad2.trafficgate.net/"]', 'a[href^="http://www.rssad.jp/"]'], adGuardMobile: ["amp-auto-ads", "#mgid_iframe", ".amp_ad", 'amp-embed[type="24smi"]', "#mgid_iframe1"], adGuardRussian: ['a[href^="https://ya-distrib.ru/r/"]', 'a[href^="https://ad.letmeads.com/"]', ".reclama", 'div[id^="smi2adblock"]', 'div[id^="AdFox_banner_"]'], adGuardSocial: ['a[href^="//www.stumbleupon.com/submit?url="]', 'a[href^="//telegram.me/share/url?"]', ".etsy-tweet", "#inlineShare", ".popup-social"], adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", '[href^="http://ads.glispa.com/"]'], adGuardTrackingProtection: ['amp-embed[type="taboola"]', "#qoo-counter", 'a[href^="http://click.hotlog.ru/"]', 'a[href^="http://hitcounter.ru/top/stat.php"]', 'a[href^="http://top.mail.ru/jump"]'], adGuardTurkish: ["#backkapat", "#reklami", 'a[href^="http://adserv.ontek.com.tr/"]', 'a[href^="http://izlenzi.com/campaign/"]', 'a[href^="http://www.installads.net/"]'], bulgarian: ["td#freenet_table_ads", "#adbody", "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"], easyList: ["#AD_banner_bottom", "#Ads_google_02", "#N-ad-article-rightRail-1", "#ad-fullbanner2", "#ad-zone-2"], easyListChina: ['a[href*=".wensixuetang.com/"]', 'A[href*="/hth107.com/"]', '.appguide-wrap[onclick*="bcebos.com"]', ".frontpageAdvM", "#taotaole"], easyListCookie: ["#adtoniq-msg-bar", "#CoockiesPage", "#CookieModal_cookiemodal", "#DO_CC_PANEL", "#ShowCookie"], easyListCzechSlovak: ["#onlajny-stickers", "#reklamni-box", ".reklama-megaboard", ".sklik", '[id^="sklikReklama"]'], easyListDutch: ["#advertentie", "#vipAdmarktBannerBlock", ".adstekst", 'a[href^="https://xltube.nl/click/"]', "#semilo-lrectangle"], easyListGermany: ['a[href^="http://www.hw-area.com/?dp="]', 'a[href^="https://ads.sunmaker.com/tracking.php?"]', ".werbung-skyscraper2", ".bannergroup_werbung", ".ads_rechts"], easyListItaly: [".box_adv_annunci", ".sb-box-pubbliredazionale", 'a[href^="http://affiliazioniads.snai.it/"]', 'a[href^="https://adserver.html.it/"]', 'a[href^="https://affiliazioniads.snai.it/"]'], easyListLithuania: [".reklamos_tarpas", ".reklamos_nuorodos", 'img[alt="Reklaminis skydelis"]', 'img[alt="Dedikuoti.lt serveriai"]', 'img[alt="Hostingas Serveriai.lt"]'], estonian: ['A[href*="http://pay4results24.eu"]'], fanboyAnnoyances: ["#feedback-tab", "#taboola-below-article", ".feedburnerFeedBlock", ".widget-feedburner-counter", '[title="Subscribe to our blog"]'], fanboyAntiFacebook: [".util-bar-module-firefly-visible"], fanboyEnhancedTrackers: [".open.pushModal", "#issuem-leaky-paywall-articles-zero-remaining-nag", "#sovrn_container", 'div[class$="-hide"][zoompage-fontsize][style="display: block;"]', ".BlockNag__Card"], fanboySocial: [".td-tags-and-social-wrapper-box", ".twitterContainer", ".youtube-social", 'a[title^="Like us on Facebook"]', 'img[alt^="Share on Digg"]'], frellwitSwedish: ['a[href*="casinopro.se"][target="_blank"]', 'a[href*="doktor-se.onelink.me"]', "article.category-samarbete", "div.holidAds", "ul.adsmodern"], greekAdBlock: ['A[href*="adman.otenet.gr/click?"]', 'A[href*="http://axiabanners.exodus.gr/"]', 'A[href*="http://interactive.forthnet.gr/click?"]', "DIV.agores300", "TABLE.advright"], hungarian: ['A[href*="ad.eval.hu"]', 'A[href*="ad.netmedia.hu"]', 'A[href*="daserver.ultraweb.hu"]', "#cemp_doboz", ".optimonk-iframe-container"], iDontCareAboutCookies: ['.alert-info[data-block-track*="CookieNotice"]', ".ModuleTemplateCookieIndicator", ".o--cookies--container", ".cookie-msg-info-container", "#cookies-policy-sticky"], icelandicAbp: ['A[href^="/framework/resources/forms/ads.aspx"]'], latvian: ['a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]', 'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]'], listKr: ['a[href*="//kingtoon.slnk.kr"]', 'a[href*="//playdsb.com/kr"]', "div.logly-lift-adz", 'div[data-widget_id="ml6EJ074"]', "ins.daum_ddn_area"], listeAr: [".geminiLB1Ad", ".right-and-left-sponsers", 'a[href*=".aflam.info"]', 'a[href*="booraq.org"]', 'a[href*="dubizzle.com/ar/?utm_source="]'], listeFr: ['a[href^="http://promo.vador.com/"]', "#adcontainer_recherche", 'a[href*="weborama.fr/fcgi-bin/"]', ".site-pub-interstitiel", 'div[id^="crt-"][data-criteo-id]'], officialPolish: ["#ceneo-placeholder-ceneo-12", '[href^="https://aff.sendhub.pl/"]', 'a[href^="http://advmanager.techfun.pl/redirect/"]', 'a[href^="http://www.trizer.pl/?utm_source"]', "div#skapiec_ad"], ro: ['a[href^="//afftrk.altex.ro/Counter/Click"]', 'a[href^="/magazin/"]', 'a[href^="https://blackfridaysales.ro/trk/shop/"]', 'a[href^="https://event.2performant.com/events/click"]', 'a[href^="https://l.profitshare.ro/"]'], ruAd: ['a[href*="//febrare.ru/"]', 'a[href*="//utimg.ru/"]', 'a[href*="://chikidiki.ru"]', "#pgeldiz", ".yandex-rtb-block"], thaiAds: ["a[href*=macau-uta-popup]", "#ads-google-middle_rectangle-group", ".ads300s", ".bumq", ".img-kosana"], webAnnoyancesUltralist: ["#mod-social-share-2", "#social-tools", ".ctpl-fullbanner", ".zergnet-recommend", ".yt.btn-link.btn-md.btn"] };

  function mt(t) {
    var e;
    return A(this, void 0, void 0, function() {
      var n, r, i, o, s, a, u;
      return x(this, function(h) {
        switch (h.label) {
          case 0:
            for (n = document, r = n.createElement("div"), i = new Array(t.length), o = {}, vt(r), u = 0; u < t.length; ++u) s = Q(t[u]), vt(a = n.createElement("div")), a.appendChild(s), r.appendChild(a), i[u] = s;
            h.label = 1;
          case 1:
            return n.body ? [3, 3] : [4, k(50)];
          case 2:
            return h.sent(), [3, 1];
          case 3:
            n.body.appendChild(r);
            try { for (u = 0; u < t.length; ++u) i[u].offsetParent || (o[t[u]] = !0) } finally { null === (e = r.parentNode) || void 0 === e || e.removeChild(r) }
            return [2, o]
        }
      })
    })
  }

  function vt(t) { t.style.setProperty("display", "block", "important") }

  function yt(t) { return matchMedia("(inverted-colors: " + t + ")").matches }

  function bt(t) { return matchMedia("(forced-colors: " + t + ")").matches }
  var wt = 100;

  function St(t) { return matchMedia("(prefers-contrast: " + t + ")").matches }

  function Tt(t) { return matchMedia("(prefers-reduced-motion: " + t + ")").matches }

  function Et(t) { return matchMedia("(dynamic-range: " + t + ")").matches }
  var Dt = Math,
    At = function() { return 0 };
  var xt = "mmMwWLliI0fiflO&1",
    It = { default: [], apple: [{ font: "-apple-system-body" }], serif: [{ fontFamily: "serif" }], sans: [{ fontFamily: "sans-serif" }], mono: [{ fontFamily: "monospace" }], min: [{ fontSize: "1px" }], system: [{ fontFamily: "system-ui" }] };
  var Rt = {
    fonts: function() {
      return W(function(t, e) {
        var n = e.document,
          r = n.body;
        r.style.fontSize = et;
        var i = n.createElement("div"),
          o = {},
          s = {},
          a = function(t) {
            var e = n.createElement("span"),
              r = e.style;
            return r.position = "absolute", r.top = "0", r.left = "0", r.fontFamily = t, e.textContent = tt, i.appendChild(e), e
          },
          u = nt.map(a),
          h = function() { for (var t = {}, e = function(e) { t[e] = nt.map(function(t) { return function(t, e) { return a("'" + t + "'," + e) }(e, t) }) }, n = 0, r = rt; n < r.length; n++) { e(r[n]) } return t }();
        r.appendChild(i);
        for (var c = 0; c < nt.length; c++) o[nt[c]] = u[c].offsetWidth, s[nt[c]] = u[c].offsetHeight;
        return rt.filter(function(t) { return e = h[t], nt.some(function(t, n) { return e[n].offsetWidth !== o[t] || e[n].offsetHeight !== s[t] }); var e })
      })
    },
    domBlockers: function(t) {
      var e = (void 0 === t ? {} : t).debug;
      return A(this, void 0, void 0, function() {
        var t, n, r, i;
        return x(this, function(o) {
          switch (o.label) {
            case 0:
              return Y() || Z() ? (t = Object.keys(gt), [4, mt((i = []).concat.apply(i, t.map(function(t) { return gt[t] })))]) : [2, void 0];
            case 1:
              return n = o.sent(), e && function(t) {
                for (var e = "DOM blockers debug:\n```", n = 0, r = Object.keys(gt); n < r.length; n++) {
                  var i = r[n];
                  e += "\n" + i + ":";
                  for (var o = 0, s = gt[i]; o < s.length; o++) {
                    var a = s[o];
                    e += "\n  " + a + " " + (t[a] ? "🚫" : "➡️")
                  }
                }
                console.log(e + "\n```")
              }(n), (r = t.filter(function(t) { var e = gt[t]; return q(e.map(function(t) { return n[t] })) > .6 * e.length })).sort(), [2, r]
          }
        })
      })
    },
    fontPreferences: function() {
      return function(t, e) {
        void 0 === e && (e = 4e3);
        return W(function(n, r) {
          var i = r.document,
            o = i.body,
            s = o.style;
          s.width = e + "px", s.webkitTextSizeAdjust = s.textSizeAdjust = "none", G() ? o.style.zoom = "" + 1 / r.devicePixelRatio : Y() && (o.style.zoom = "reset");
          var a = i.createElement("div");
          return a.textContent = I(Array(e / 20 << 0)).map(function() { return "word" }).join(" "), o.appendChild(a), t(i, o)
        }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">')
      }(function(t, e) {
        for (var n = {}, r = {}, i = 0, o = Object.keys(It); i < o.length; i++) {
          var s = o[i],
            a = It[s],
            u = a[0],
            h = void 0 === u ? {} : u,
            c = a[1],
            l = void 0 === c ? xt : c,
            f = t.createElement("span");
          f.textContent = l, f.style.whiteSpace = "nowrap";
          for (var d = 0, p = Object.keys(h); d < p.length; d++) {
            var g = p[d],
              m = h[g];
            void 0 !== m && (f.style[g] = m)
          }
          n[s] = f, e.appendChild(t.createElement("br")), e.appendChild(f)
        }
        for (var v = 0, y = Object.keys(It); v < y.length; v++) { r[s = y[v]] = n[s].getBoundingClientRect().width }
        return r
      })
    },
    audio: function() {
      var t = window,
        e = t.OfflineAudioContext || t.webkitOfflineAudioContext;
      if (!e) return -2;
      if (function() { return Y() && !X() && (t = window, !(q(["DOMRectList" in t, "RTCPeerConnectionIceEvent" in t, "SVGGeometryElement" in t, "ontransitioncancel" in t]) >= 3)); var t }()) return -1;
      var n = new e(1, 5e3, 44100),
        r = n.createOscillator();
      r.type = "triangle", r.frequency.value = 1e4;
      var i = n.createDynamicsCompressor();
      i.threshold.value = -50, i.knee.value = 40, i.ratio.value = 12, i.attack.value = 0, i.release.value = .25, r.connect(i), i.connect(n.destination), r.start(0);
      var o = function(t) {
          var e = function() {};
          return [new Promise(function(n, r) {
            var i = !1,
              o = 0,
              s = 0;
            t.oncomplete = function(t) { return n(t.renderedBuffer) };
            var a = function() { setTimeout(function() { return r(J("timeout")) }, Math.min(500, s + 5e3 - Date.now())) },
              u = function() {
                try {
                  switch (t.startRendering(), t.state) {
                    case "running":
                      s = Date.now(), i && a();
                      break;
                    case "suspended":
                      document.hidden || o++, i && o >= 3 ? r(J("suspended")) : setTimeout(u, 500)
                  }
                } catch (t) { r(t) }
              };
            u(), e = function() { i || (i = !0, s > 0 && a()) }
          }), e]
        }(n),
        s = o[0],
        a = o[1],
        u = s.then(function(t) { return function(t) { for (var e = 0, n = 0; n < t.length; ++n) e += Math.abs(t[n]); return e }(t.getChannelData(0).subarray(4500)) }, function(t) { if ("timeout" === t.name || "suspended" === t.name) return -3; throw t });
      return u.catch(function() {}),
        function() { return a(), u }
    },
    screenFrame: function() {
      var t = this,
        e = ft();
      return function() {
        return A(t, void 0, void 0, function() {
          var t, n;
          return x(this, function(r) {
            switch (r.label) {
              case 0:
                return [4, e()];
              case 1:
                return t = r.sent(), [2, [(n = function(t) { return null === t ? null : F(t, lt) })(t[0]), n(t[1]), n(t[2]), n(t[3])]]
            }
          })
        })
      }
    },
    osCpu: function() { return navigator.oscpu },
    languages: function() {
      var t, e = navigator,
        n = [],
        r = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
      if (void 0 !== r && n.push([r]), Array.isArray(e.languages)) G() && q([!("MediaSettingsRange" in (t = window)), "RTCEncodedAudioFrame" in t, "" + t.Intl == "[object Intl]", "" + t.Reflect == "[object Reflect]"]) >= 3 || n.push(e.languages);
      else if ("string" == typeof e.languages) {
        var i = e.languages;
        i && n.push(i.split(","))
      }
      return n
    },
    colorDepth: function() { return window.screen.colorDepth },
    deviceMemory: function() { return H(j(navigator.deviceMemory), void 0) },
    screenResolution: function() {
      var t = screen,
        e = function(t) { return H(_(t), null) },
        n = [e(t.width), e(t.height)];
      return n.sort().reverse(), n
    },
    hardwareConcurrency: function() { return H(_(navigator.hardwareConcurrency), void 0) },
    timezone: function() { var t, e = null === (t = window.Intl) || void 0 === t ? void 0 : t.DateTimeFormat; if (e) { var n = (new e).resolvedOptions().timeZone; if (n) return n } var r, i = (r = (new Date).getFullYear(), -Math.max(j(new Date(r, 0, 1).getTimezoneOffset()), j(new Date(r, 6, 1).getTimezoneOffset()))); return "UTC" + (i >= 0 ? "+" : "") + Math.abs(i) },
    sessionStorage: function() { try { return !!window.sessionStorage } catch (t) { return !0 } },
    localStorage: function() { try { return !!window.localStorage } catch (t) { return !0 } },
    indexedDB: function() { var t, e; if (!(K() || (t = window, e = navigator, q(["msWriteProfilerMark" in t, "MSStream" in t, "msLaunchUri" in e, "msSaveBlob" in e]) >= 3 && !K()))) try { return !!window.indexedDB } catch (t) { return !0 } },
    openDatabase: function() { return !!window.openDatabase },
    cpuClass: function() { return navigator.cpuClass },
    platform: function() {
      var t = navigator.platform;
      return "MacIntel" === t && Y() && !X() ? function() {
        if ("iPad" === navigator.platform) return !0;
        var t = screen,
          e = t.width / t.height;
        return q(["MediaSource" in window, !!Element.prototype.webkitRequestFullscreen, e > .65 && e < 1.53]) >= 2
      }() ? "iPad" : "iPhone" : t
    },
    plugins: function() {
      var t = navigator.plugins;
      if (t) {
        for (var e = [], n = 0; n < t.length; ++n) {
          var r = t[n];
          if (r) {
            for (var i = [], o = 0; o < r.length; ++o) {
              var s = r[o];
              i.push({ type: s.type, suffixes: s.suffixes })
            }
            e.push({ name: r.name, description: r.description, mimeTypes: i })
          }
        }
        return e
      }
    },
    canvas: function() {
      var t = function() { var t = document.createElement("canvas"); return t.width = 1, t.height = 1, [t, t.getContext("2d")] }(),
        e = t[0],
        n = t[1];
      return function(t, e) { return !(!e || !t.toDataURL) }(e, n) ? { winding: it(n), geometry: st(e, n), text: ot(e, n) } : { winding: !1, geometry: "", text: "" }
    },
    touchSupport: function() {
      var t, e = navigator,
        n = 0;
      void 0 !== e.maxTouchPoints ? n = _(e.maxTouchPoints) : void 0 !== e.msMaxTouchPoints && (n = e.msMaxTouchPoints);
      try { document.createEvent("TouchEvent"), t = !0 } catch (e) { t = !1 }
      return { maxTouchPoints: n, touchEvent: t, touchStart: "ontouchstart" in window }
    },
    vendor: function() { return navigator.vendor || "" },
    vendorFlavors: function() {
      for (var t = [], e = 0, n = ["chrome", "safari", "__crWeb", "__gCrWeb", "yandex", "__yb", "__ybro", "__firefox__", "__edgeTrackingPreventionStatistics", "webkit", "oprt", "samsungAr", "ucweb", "UCShellJava", "puffinDevice"]; e < n.length; e++) {
        var r = n[e],
          i = window[r];
        i && "object" == typeof i && t.push(r)
      }
      return t.sort()
    },
    cookiesEnabled: function() { var t = document; try { t.cookie = "cookietest=1; SameSite=Strict;"; var e = -1 !== t.cookie.indexOf("cookietest="); return t.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", e } catch (t) { return !1 } },
    colorGamut: function() { for (var t = 0, e = ["rec2020", "p3", "srgb"]; t < e.length; t++) { var n = e[t]; if (matchMedia("(color-gamut: " + n + ")").matches) return n } },
    invertedColors: function() { return !!yt("inverted") || !yt("none") && void 0 },
    forcedColors: function() { return !!bt("active") || !bt("none") && void 0 },
    monochrome: function() {
      if (matchMedia("(min-monochrome: 0)").matches) {
        for (var t = 0; t <= wt; ++t)
          if (matchMedia("(max-monochrome: " + t + ")").matches) return t;
        throw new Error("Too high value")
      }
    },
    contrast: function() { return St("no-preference") ? 0 : St("high") || St("more") ? 1 : St("low") || St("less") ? -1 : St("forced") ? 10 : void 0 },
    reducedMotion: function() { return !!Tt("reduce") || !Tt("no-preference") && void 0 },
    hdr: function() { return !!Et("high") || !Et("standard") && void 0 },
    math: function() {
      var t, e = Dt.acos || At,
        n = Dt.acosh || At,
        r = Dt.asin || At,
        i = Dt.asinh || At,
        o = Dt.atanh || At,
        s = Dt.atan || At,
        a = Dt.sin || At,
        u = Dt.sinh || At,
        h = Dt.cos || At,
        c = Dt.cosh || At,
        l = Dt.tan || At,
        f = Dt.tanh || At,
        d = Dt.exp || At,
        p = Dt.expm1 || At,
        g = Dt.log1p || At;
      return { acos: e(.12312423423423424), acosh: n(1e308), acoshPf: (t = 1e154, Dt.log(t + Dt.sqrt(t * t - 1))), asin: r(.12312423423423424), asinh: i(1), asinhPf: function(t) { return Dt.log(t + Dt.sqrt(t * t + 1)) }(1), atanh: o(.5), atanhPf: function(t) { return Dt.log((1 + t) / (1 - t)) / 2 }(.5), atan: s(.5), sin: a(-1e300), sinh: u(1), sinhPf: function(t) { return Dt.exp(t) - 1 / Dt.exp(t) / 2 }(1), cos: h(10.000000000123), cosh: c(1), coshPf: function(t) { return (Dt.exp(t) + 1 / Dt.exp(t)) / 2 }(1), tan: l(-1e300), tanh: f(1), tanhPf: function(t) { return (Dt.exp(2 * t) - 1) / (Dt.exp(2 * t) + 1) }(1), exp: d(1), expm1: p(1), expm1Pf: function(t) { return Dt.exp(t) - 1 }(1), log1p: g(10), log1pPf: function(t) { return Dt.log(1 + t) }(10), powPI: function(t) { return Dt.pow(Dt.PI, t) }(-100) }
    }
  };
  var kt = "$ if upgrade to Pro: https://fpjs.dev/pro";

  function Bt(t) {
    var e = function(t) { if (Z()) return .4; if (Y()) return X() ? .5 : .3; var e = t.platform.value || ""; if (/^Win/.test(e)) return .6; if (/^Mac/.test(e)) return .5; return .7 }(t),
      n = function(t) { return F(.99 + .01 * t, 1e-4) }(e);
    return { score: e, comment: kt.replace(/\$/g, "" + n) }
  }

  function Ot(t) { return JSON.stringify(t, function(t, e) { return e instanceof Error ? D({ name: (n = e).name, message: n.message, stack: null === (r = n.stack) || void 0 === r ? void 0 : r.split("\n") }, n) : e; var n, r }, 2) }

  function Ct(t) {
    return function(t, e) {
      e = e || 0;
      var n, r = (t = t || "").length % 16,
        i = t.length - r,
        o = [0, e],
        s = [0, e],
        a = [0, 0],
        u = [0, 0],
        h = [2277735313, 289559509],
        c = [1291169091, 658871167];
      for (n = 0; n < i; n += 16) a = [255 & t.charCodeAt(n + 4) | (255 & t.charCodeAt(n + 5)) << 8 | (255 & t.charCodeAt(n + 6)) << 16 | (255 & t.charCodeAt(n + 7)) << 24, 255 & t.charCodeAt(n) | (255 & t.charCodeAt(n + 1)) << 8 | (255 & t.charCodeAt(n + 2)) << 16 | (255 & t.charCodeAt(n + 3)) << 24], u = [255 & t.charCodeAt(n + 12) | (255 & t.charCodeAt(n + 13)) << 8 | (255 & t.charCodeAt(n + 14)) << 16 | (255 & t.charCodeAt(n + 15)) << 24, 255 & t.charCodeAt(n + 8) | (255 & t.charCodeAt(n + 9)) << 8 | (255 & t.charCodeAt(n + 10)) << 16 | (255 & t.charCodeAt(n + 11)) << 24], a = M(a = N(a, h), 31), o = C(o = M(o = V(o, a = N(a, c)), 27), s), o = C(N(o, [0, 5]), [0, 1390208809]), u = M(u = N(u, c), 33), s = C(s = M(s = V(s, u = N(u, h)), 31), o), s = C(N(s, [0, 5]), [0, 944331445]);
      switch (a = [0, 0], u = [0, 0], r) {
        case 15:
          u = V(u, P([0, t.charCodeAt(n + 14)], 48));
        case 14:
          u = V(u, P([0, t.charCodeAt(n + 13)], 40));
        case 13:
          u = V(u, P([0, t.charCodeAt(n + 12)], 32));
        case 12:
          u = V(u, P([0, t.charCodeAt(n + 11)], 24));
        case 11:
          u = V(u, P([0, t.charCodeAt(n + 10)], 16));
        case 10:
          u = V(u, P([0, t.charCodeAt(n + 9)], 8));
        case 9:
          u = N(u = V(u, [0, t.charCodeAt(n + 8)]), c), s = V(s, u = N(u = M(u, 33), h));
        case 8:
          a = V(a, P([0, t.charCodeAt(n + 7)], 56));
        case 7:
          a = V(a, P([0, t.charCodeAt(n + 6)], 48));
        case 6:
          a = V(a, P([0, t.charCodeAt(n + 5)], 40));
        case 5:
          a = V(a, P([0, t.charCodeAt(n + 4)], 32));
        case 4:
          a = V(a, P([0, t.charCodeAt(n + 3)], 24));
        case 3:
          a = V(a, P([0, t.charCodeAt(n + 2)], 16));
        case 2:
          a = V(a, P([0, t.charCodeAt(n + 1)], 8));
        case 1:
          a = N(a = V(a, [0, t.charCodeAt(n)]), h), o = V(o, a = N(a = M(a, 31), c))
      }
      return o = C(o = V(o, [0, t.length]), s = V(s, [0, t.length])), s = C(s, o), o = C(o = L(o), s = L(s)), s = C(s, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (s[1] >>> 0).toString(16)).slice(-8)
    }(function(t) {
      for (var e = "", n = 0, r = Object.keys(t).sort(); n < r.length; n++) {
        var i = r[n],
          o = t[i],
          s = o.error ? "error" : JSON.stringify(o.value);
        e += (e ? "|" : "") + i.replace(/([:|\\])/g, "\\$1") + ":" + s
      }
      return e
    }(t))
  }

  function Nt(t) {
    return void 0 === t && (t = 50),
      function(t, e) { void 0 === e && (e = 1 / 0); var n = window.requestIdleCallback; return n ? new Promise(function(t) { return n.call(window, function() { return t() }, { timeout: e }) }) : k(Math.min(t, e)) }(t, 2 * t)
  }

  function Mt(t, e) {
    var n = Date.now();
    return {
      get: function(r) {
        return A(this, void 0, void 0, function() {
          var i, o, s;
          return x(this, function(a) {
            switch (a.label) {
              case 0:
                return i = Date.now(), [4, t()];
              case 1:
                return o = a.sent(), s = function(t) { var e; return {get visitorId() { return void 0 === e && (e = Ct(this.components)), e }, set visitorId(t) { e = t }, confidence: Bt(t), components: t, version: R } }(o), (e || (null == r ? void 0 : r.debug)) && console.log("Copy the text below to get the debug data:\n\n```\nversion: " + s.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (i - n) + "\nvisitorId: " + s.visitorId + "\ncomponents: " + Ot(o) + "\n```"), [2, s]
            }
          })
        })
      }
    }
  }
  var Pt = {
    load: function(t) {
      var e = void 0 === t ? {} : t,
        n = e.delayFallback,
        r = e.debug,
        i = e.monitoring,
        o = void 0 === i || i;
      return A(this, void 0, void 0, function() {
        return x(this, function(t) {
          switch (t.label) {
            case 0:
              return o && function() {
                if (!(window.__fpjs_d_m || Math.random() >= .01)) try {
                  var t = new XMLHttpRequest;
                  t.open("get", "https://openfpcdn.io/fingerprintjs/v" + R + "/npm-monitoring", !0), t.send()
                } catch (t) { console.error(t) }
              }(), [4, Nt(n)];
            case 1:
              return t.sent(), [2, Mt(z(Rt, { debug: r }, []), r)]
          }
        })
      })
    },
    hashComponents: Ct,
    componentsToDebugString: Ot
  };
  async function Vt() { return async function() { let t = await Pt.load(); return await t.get() }().then(t => (function(t) { const e = t.components; return { httpBrowserColorDepth: _t(e.colorDepth.value), httpBrowserJavaEnabled: jt(!1), httpBrowserJavaScriptEnabled: !0, httpBrowserLanguage: Lt(e.languages.value[0][0], "pt-BR"), httpBrowserScreenHeight: _t(e.screenResolution.value[1]), httpBrowserScreenWidth: _t(e.screenResolution.value[0]), httpBrowserTimeDifference: (new Date).getTimezoneOffset(), httpDeviceChannel: "Browser", userAgentBrowserValue: navigator.userAgent } })(t)).catch(() => null) }

  function Lt(t, e) { return void 0 === t ? e : t }

  function _t(t) { return !isNaN(parseFloat(t)) && isFinite(t) ? t : null }

  function jt(t) { return "boolean" == typeof t || "true" === t || "false" === t ? t : null }

  function Ht(t) {
    switch (t) {
      case "INVALID_NUMBER":
        return "paymentMethod.card.number";
      case "INVALID_EXPIRATION_MONTH":
        return "paymentMethod.card.expMonth";
      case "INVALID_EXPIRATION_YEAR":
        return "paymentMethod.card.expYear";
      case "INVALID_HOLDER":
        return "paymentMethod.card.holder.name";
      default:
        return "paymentMethod.card"
    }
  }
  return t.PagSeguroError = w, t.authenticate3DS = async function(t) {
    let e = await async function(t) {
        const e = await async function(t) {
            if (function(t) { return t.paymentMethod && t.paymentMethod.card }(t) && t.paymentMethod.card.number) {
              let n = t.paymentMethod.card,
                r = await async function() { return S({ url: b.urls().checkoutSdkService + "/public-key", method: "GET" }) }();
              const i = y({ publicKey: r.publicKey, holder: n.holder ? n.holder.name : "", number: n.number, expMonth: n.expMonth, expYear: n.expYear });
              if (i.hasErrors) throw new w("Invalid parameter", { httpStatus: 400, traceId: "clientSdkError", message: "Invalid Parameters", errorMessages: (e = i.errors, e.map(function(t) { return { code: "40002", description: t.message, parameterName: Ht(t.code) } })) });
              t.paymentMethod.card = { encrypted: i.encryptedCard }
            }
            var e
          }(t),
          n = await async function(t) { try { t.deviceInformation = await Vt() } catch { t.deviceInformation = null } }(t);
        return Promise.all([e, n]).then(() => t)
      }(t.data),
      n = await async function(t) { return S({ url: b.urls().checkoutSdkService + "/3ds/authentications", method: "POST", body: t }) }(e);
    if ("REQUIRE_INITIALIZATION" != n.status) return n;
    if (await async function(t) {
        let e = new Promise((t, e) => { setTimeout(() => { e(new w("Error in Songbird setup", { httpStatus: 500, traceId: "songbirdSdkError", message: "Error in Songbird setup" })) }, 15e3) }),
          n = new Promise((e, n) => {
            if ("SANDBOX" == b.getEnvironment()) return e();
            let r = function() { T = !0, Cardinal.off("payments.setupComplete"), Cardinal.on("payments.setupComplete", function(n) { Cardinal.trigger("accountNumber.update", t.bin).then(t => e()) }), Cardinal.setup("init", { jwt: t.jwt }) };
            if (T) r();
            else {
              var i = document.getElementsByTagName("head")[0],
                o = document.createElement("script");
              o.type = "text/javascript", o.src = b.urls().songbird, o.onreadystatechange = r, o.onload = r, i.appendChild(o)
            }
          });
        return Promise.race([e, n])
      }(n.initialization), "REQUIRE_CHALLENGE" != (n = await async function(t) { return S({ url: b.urls().checkoutSdkService + "/3ds/authentications/" + t, method: "POST" }) }(n.id)).status) return n;
    let r = await async function(t, e) { return "SANDBOX" == b.getEnvironment() ? new Promise((n, r) => { const i = function() { window.confirm("Para continuar confirme essa transação.") ? n(t.payload) : n(E) }; "function" == typeof e ? e({ open: i, brand: t.brand, issuer: t.issuer }) : i() }) : new Promise((n, r) => { Cardinal.off("payments.validated"), Cardinal.on("payments.validated", function(t, e) { e ? n(e) : r(new w("Error while processing challenge", { httpStatus: 502, traceId: "songbirdSdkError", message: "Error while processing challenge: " + JSON.stringify(t) })) }); const i = function() { Cardinal.continue("cca", { AcsUrl: t.acsUrl, Payload: t.payload }, { OrderDetails: { TransactionId: t.transactionId } }) }; "function" == typeof e ? e({ open: i, brand: t.brand, issuer: t.issuer }) : i() }) }(n.challenge, t.beforeChallenge);
    return n = await async function(t, e) { return S({ url: b.urls().checkoutSdkService + "/3ds/authentications/" + t, method: "PATCH", body: { jwt: e } }) }(n.id, r)
  }, t.encryptCard = y, t.env = { PROD: "PROD", SANDBOX: "SANDBOX" }, t.setUp = t => {
    t && (t.env && function(t) {
      switch (t) {
        case "LOCAL":
        case "QA":
        case "SANDBOX-QA":
        case "SANDBOX":
        case "PROD":
          break;
        default:
          throw new w("Invalid environment", { httpStatus: "400", traceId: "clientSdkError", message: "Invalid Parameters", errorMessages: [{ code: "40002", description: "allowed values are: [PROD, SANDBOX]", parameterName: "env" }] })
      }
    }(t.env), b.setUp(t))
  }, t
}({});

export default PagSeguro;